import ErrorBoundary from "../components/ErrorBoundary";
import React, { useState, useEffect, useRef, useMemo } from 'react';
import ImageCropperModal from '../components/ImageCropperModal';
import { getSharedFilters, saveSharedFilters } from '../utils/filterStore';
import axios from 'axios';
import { API_URL as CONFIG_API_URL } from '../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';

import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  RadialLinearScale,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Doughnut, Bar, Radar, Line } from 'react-chartjs-2';
import { X, Sparkles, MessageSquare, Target, Activity, FileText, ExternalLink, Check, Filter, ChevronDown, Calendar, Users } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import { Download, FileSpreadsheet, Search, Loader2, Bot, ShoppingBag, Crop } from 'lucide-react';
import WordCloudCard from '../components/WordCloudCard';
import PersonaInsightsTab from '../components/PersonaInsightsTab';


function extractTrailingJSON(text) {
    const lastClose = text.lastIndexOf(']');
    if (lastClose === -1) return null;
    let idx = text.indexOf('[');
    while (idx !== -1 && idx < lastClose) {
        try {
            const parsed = JSON.parse(text.substring(idx, lastClose + 1));
            if (Array.isArray(parsed) && parsed.length > 0 && (parsed[0].url || parsed[0].link || parsed[0].URL || parsed[0].Url)) {
                return { parsed, startIdx: idx, endIdx: lastClose };
            }
        } catch (e) { }
        idx = text.indexOf('[', idx + 1);
    }
    return null;
}

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  RadialLinearScale,
  Tooltip,
  Legend,
  Filler
);

import narrativeData from '../data/hermes_insight_report.json';

export default function BrandInsights() {
  const [globalBrand, setGlobalBrand] = useState(localStorage.getItem('globalBrand') || 'all');
  const [globalProject, setGlobalProject] = useState(localStorage.getItem('globalProject') || 'all');
  const [globalFetchMode, setGlobalFetchMode] = useState(localStorage.getItem('globalFetchMode') || 'hybrid');
  const [activeView, setActiveView] = useState("global");
  const [openDropdown, setOpenDropdown] = useState(null);
  const filterBarRef = useRef(null);
  const [projectPersonas, setProjectPersonas] = useState(['全部人设']);
  const [projectPackages, setProjectPackages] = useState(['全部词包']);
  const [filters, setFilters] = useState(() => getSharedFilters({
    time: '最近 30 天',
    customDate: { start: '', end: '' },
    engines: ['全部 AI 引擎'],
    stages: ['全部阶段'],
    personas: ['全部人设'],
    packages: ['全部词包']
  }));
  
  useEffect(() => {
    saveSharedFilters(filters);
  }, [filters]);

  useEffect(() => {
    const handleGlobalFilterChange = () => {
      setGlobalBrand(localStorage.getItem('globalBrand') || 'all');
      setGlobalProject(localStorage.getItem('globalProject') || 'all');
      setGlobalFetchMode(localStorage.getItem('globalFetchMode') || 'hybrid');
    };
    window.addEventListener('globalFilterChange', handleGlobalFilterChange);
    return () => window.removeEventListener('globalFilterChange', handleGlobalFilterChange);
  }, []);

  const toggleDropdown = (name) => {
    setOpenDropdown(prev => prev === name ? null : name);
  };

  const toggleArrayFilter = (key, value, defaultAll) => {
    setFilters(prev => {
      let current = [...prev[key]];
      if (value === defaultAll) return { ...prev, [key]: [defaultAll] };
      current = current.filter(v => v !== defaultAll);
      if (current.includes(value)) {
        current = current.filter(v => v !== value);
        if (current.length === 0) current = [defaultAll];
      } else {
        current.push(value);
      }
      return { ...prev, [key]: current };
    });
  };

  const updateTimeFilter = (val) => {
    setFilters(prev => ({ ...prev, time: val }));
    if (val !== '自定义范围') setOpenDropdown(null);
  };

  const renderArrayLabel = (arr, defaultAll, prefix = '') => {
    if (arr.includes(defaultAll)) return `${prefix}${defaultAll}`;
    if (arr.length === 1) return `${prefix}${arr[0]}`;
    return `${prefix}已选 ${arr.length} 项`;
  };

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (filterBarRef.current && !filterBarRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fetch Project Personas

  useEffect(() => {
    const fetchPersonas = async () => {
      const token = localStorage.getItem('token');
      const bid = globalBrand;
      let combinedPersonas = ['全部人设'];
      try {
        const sysRes = await axios.get(`${API_URL}/personas/system`);
        if (sysRes.data && Array.isArray(sysRes.data)) {
           combinedPersonas.push(...sysRes.data.map(p => p.name));
        }
      } catch(error) { console.error("Failed to fetch system personas"); }

      try {
        if (bid && bid !== 'all' && bid !== 'undefined') {
          const brandRes = await axios.get(`${API_URL}/brand-projects/${bid}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (brandRes.data && brandRes.data.data) {
             if (brandRes.data.data.personas) {
                 const brandPersonas = brandRes.data.data.personas.map(p => p.name);
                 combinedPersonas.push(...brandPersonas);
             }
             if (brandRes.data.data.keywordPackages) {
                 const pkgs = brandRes.data.data.keywordPackages.map(p => p.name).filter(n => n !== '未分类');
                 setProjectPackages(['全部词包', ...new Set(pkgs)]);
             }
          }
        }
      } catch(error) { console.error("Failed to fetch brand personas"); }
      
      setProjectPersonas([...new Set(combinedPersonas)]);
    };
    fetchPersonas();
  }, [globalBrand]);

  const [activeEngineTab, setActiveEngineTab] = useState("all");
  const [activeDimTab, setActiveDimTab] = useState("品牌知识");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState('');
  const [drawerData, setDrawerData] = useState([]);
  const [drawerLoading, setDrawerLoading] = useState(false);

  // Media & Article Type Drawer State
  const [isMediaDrawerOpen, setIsMediaDrawerOpen] = useState(false);
  const [mediaDrawerTitle, setMediaDrawerTitle] = useState('');
  const [mediaDrawerData, setMediaDrawerData] = useState([]);
  const [mediaDrawerLoading, setMediaDrawerLoading] = useState(false);

  // Zhimo Drawer State
  const [isZhimoDrawerOpen, setIsZhimoDrawerOpen] = useState(false);
  const [zhimoCitation, setZhimoCitation] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [zhimoStatuses, setZhimoStatuses] = useState({}); // { id: 'idle'|'generating'|'completed' }
  const [zhimoPlatform, setZhimoPlatform] = useState('GENERAL_NEWS');
  const [zhimoTone, setZhimoTone] = useState('专家科普');
  const [zhimoResults, setZhimoResults] = useState({});
  const [zhimoSelectedSources, setZhimoSelectedSources] = useState([]);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [cropTarget, setCropTarget] = useState(null);


  const openMediaEvidenceDrawer = async (title) => {
    setMediaDrawerTitle(title);
    setIsMediaDrawerOpen(true);
    setMediaDrawerLoading(true);
    
    try {
      const globalProjectLocal = globalProject;
      const taskId = (globalProjectLocal === 'all' || globalProjectLocal === 'undefined' || !globalProjectLocal) ? undefined : globalProjectLocal;
      const globalBrandLocal = globalBrand;
      const brandId = (globalBrandLocal === 'all' || globalBrandLocal === 'undefined' || !globalBrandLocal) ? undefined : globalBrandLocal;
      
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      
      const res = await axios.get(`${API_URL}/results`, {
        headers,
        params: {
            fetchMode: localStorage.getItem('globalFetchMode') || 'hybrid',
          geoTaskId: taskId,
          brandProjectId: brandId,
          limit: 150 // Pull more for media/article type view
        }
      });
      
      if (res.data.success && res.data.data) {
        // Build a flattened list of media sources from the results
        let flatMediaList = [];
        res.data.data.forEach(r => {
           let sourcesList = [];
           if (r.sources) {
             try { sourcesList = JSON.parse(r.sources); } catch(e){}
           }
           const brands = r.mentionedBrands ? (typeof r.mentionedBrands==='string' ? JSON.parse(r.mentionedBrands) : r.mentionedBrands) : [];
           const fType = (r.funnelStage || 'awareness').toLowerCase();
           const typeMapping = {
              'awareness': '新闻通稿/科普',
              'appeal': '评测文章/KOL种草',
              'ask': '用户提问/社区问答',
              'action': '导购比价/成交单'
           };
           const articleType = typeMapping[fType] || '新闻通稿/科普';
           
           if (r.xhsRawNotes && r.xhsRawNotes.length > 0) {
              r.xhsRawNotes.forEach((note, idx) => {
                 flatMediaList.push({
                   id: `${r.id}-小红书-${idx}`,
                   resultId: r.id,
                   engineName: r.engineName,
                   platform: '小红书',
                   articleType: articleType,
                   title: note.title || r.question,
                   url: note.noteUrl || '#',
                   sentiment: r.sentiment,
                   brands: brands,
                   authorName: note.nickname || '-',
                   recommendType: note.sourceScope || '未知',
                   description: note.content || '-',
                   likes: note.likeCount || 0,
                   comments: note.commentCount || 0,
                   shares: note.shareCount || 0
                 });
              });
           } else {
             sourcesList.forEach(s => {
                let platform = s.platform || s.name || s.mediaName;
                if (platform) {
                   platform = platform.replace(/-.*/, '').trim();

            let lowerPlatform = platform.toLowerCase();
            if (lowerPlatform.includes('hermès') || lowerPlatform.includes('hermes') || lowerPlatform.includes('爱马仕')) {
                platform = '爱马仕官网';
            } else if (lowerPlatform.includes('k.sina.com.cn') || lowerPlatform.includes('sina') || lowerPlatform.includes('新浪')) {
                platform = '新浪网';
            } else if (lowerPlatform.includes('sohu') || lowerPlatform.includes('搜狐')) {
                platform = '搜狐网';
            } else if (lowerPlatform.includes('163.com') || lowerPlatform.includes('网易')) {
                platform = '网易网';
            } else if (lowerPlatform.includes('baidu') || lowerPlatform.includes('百度') || lowerPlatform.includes('baijiahao') || lowerPlatform.includes('百家号') || lowerPlatform.includes('百度百科')) {
                platform = '百度(含百科/百家号)';
            } else if (lowerPlatform.includes('weibo') || lowerPlatform.includes('微博')) {
                platform = '微博';
            } else if (lowerPlatform.includes('xhslink') || lowerPlatform.includes('xiaohongshu') || lowerPlatform.includes('小红书')) {
                platform = '小红书';
            } else if (lowerPlatform.includes('weixin') || lowerPlatform.includes('微信') || lowerPlatform.includes('公众号') || lowerPlatform.includes('mp.weixin.qq.com')) {
                platform = '微信公众号';
            } else if (lowerPlatform.includes('zhihu') || lowerPlatform.includes('知乎')) {
                platform = '知乎';
            } else if (lowerPlatform.includes('thepaper') || lowerPlatform.includes('澎湃')) {
                platform = '澎湃新闻';
            } else if (lowerPlatform.includes('bilibili') || lowerPlatform.includes('哔哩哔哩')) {
                platform = 'B站(Bilibili)';
            } else if (lowerPlatform.includes('douyin') || lowerPlatform.includes('抖音')) {
                platform = '抖音';
            } else if (lowerPlatform.includes('pcauto.com.cn') || lowerPlatform.includes('太平洋汽车')) {
                platform = '太平洋汽车';
            } else if (lowerPlatform.includes('autohome.com.cn') || lowerPlatform.includes('汽车之家')) {
                platform = '汽车之家';
            } else if (lowerPlatform.includes('dongchedi.com') || lowerPlatform.includes('懂车帝')) {
                platform = '懂车帝';
            } else if (lowerPlatform.includes('yiche.com') || lowerPlatform.includes('易车') || lowerPlatform.includes('bitauto.com')) {
                platform = '易车';
            } else if (lowerPlatform.includes('toutiao') || lowerPlatform.includes('头条')) {
                platform = '今日头条';
            } else if (lowerPlatform.includes('christie') || lowerPlatform.includes('佳士得')) {
                platform = '佳士得';
            } else if (lowerPlatform.includes('vogue')) {
                platform = 'Vogue';
            }

                   flatMediaList.push({
                     id: `${r.id}-${platform}`,
                     resultId: r.id,
                     engineName: r.engineName,
                     platform: platform,
                     articleType: articleType,
                     title: s.title || r.question,
                     url: s.url || '#',
                     sentiment: r.sentiment,
                     brands: brands,
                     authorName: '-',
                     recommendType: '-',
                     description: '-',
                     likes: '-',
                     comments: '-',
                     shares: '-'
                   });
                }
             });
           }
        });
        setMediaDrawerData(flatMediaList);
      } else {
        setMediaDrawerData([]);
      }
    } catch (_err) {
      console.error("Failed to fetch media drawer data:", err);
      setMediaDrawerData([]);
    } finally {
      setMediaDrawerLoading(false);
    }
  };

  const closeMediaDrawer = () => setIsMediaDrawerOpen(false);

  const handleExportMediaExcel = () => {
    if (!mediaDrawerData || mediaDrawerData.length === 0) return;
    
    const excelData = [
      ['序号', '来源媒体', '内容类型', '引用 AI 引擎', '情感偏向', '提及品牌', '文章标题/触发问题', '来源链接', '笔记博主名字', '推荐类型', '内容描述', '点赞数', '评论数', '转发数']
    ];
    
    const sentimentMap = { 'positive': '正面', 'neutral': '中立', 'negative': '负面', 'controversial': '争议' };
    
    mediaDrawerData.forEach((row, idx) => {
      excelData.push([
        idx + 1,
        row.platform || '',
        row.articleType || '',
        row.engineName || '',
        sentimentMap[row.sentiment] || '中立',
        Array.isArray(row.brands) ? row.brands.join(', ') : '',
        row.title || '',
        row.url || '',
        row.authorName || '-',
        row.recommendType || '-',
        row.description || '-',
        row.likes || '-',
        row.comments || '-',
        row.shares || '-'
      ]);
    });
    
    // Using simple CSV generation for quick download (or xlsx library if loaded globally)
    try {
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "媒体内容溯源明细");
        XLSX.writeFile(wb, `媒体明细导出_${new Date().getTime()}.xlsx`);
    } catch(e) {
        // Fallback to CSV if XLSX is not imported
        let csvContent = "\uFEFF" + excelData.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `媒体明细导出_${new Date().getTime()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
  };

  
    const handleCropComplete = async (base64Image) => {
        if (!cropTarget) return;
        try {
            const resRaw = await fetch(`/api/results/${cropTarget.recordId}/update-card-image`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({
                    cardIndex: cropTarget.cardIndex,
                    base64Image
                })
            });
            const res = { data: await resRaw.json() };
            if (res.data.success) {
                // Update local state so it reflects immediately
                setEvidenceList(prev => prev.map(item => {
                    if (item.id === cropTarget.recordId) {
                        const newCards = [...item.productCards];
                        newCards[cropTarget.cardIndex].imageUrl = res.data.newImageUrl;
                        return { ...item, productCards: newCards };
                    }
                    return item;
                }));
                setCropTarget(null);
            }
        } catch (e) {
            console.error('Crop save error', e);
            alert('保存截图失败');
        }
    };
  
    const openEvidenceDrawer = async (title, queryParams) => {
    setDrawerTitle(title);
    setIsDrawerOpen(true);
    setDrawerLoading(true);
    
    try {
      const { brand, sentiment, cons, pros } = queryParams;
      const globalProjectLocal = globalProject;
      const taskId = (globalProjectLocal === 'all' || globalProjectLocal === 'undefined' || !globalProjectLocal) ? undefined : globalProjectLocal;
      const globalBrandLocal = globalBrand;
      const brandId = (globalBrandLocal === 'all' || globalBrandLocal === 'undefined' || !globalBrandLocal) ? undefined : globalBrandLocal;
      
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      
      // We pass the brand and sentiment to filter the API. 
      // If 'cons' is passed, we could theoretically do a full text search, but for now we just filter by brand and negative.
      const fetchSentiment = cons ? 'negative' : (pros ? 'positive' : sentiment);
      
      const res = await axios.get(`${API_URL}/results`, {
        headers,
        params: {
            fetchMode: localStorage.getItem('globalFetchMode') || 'hybrid',
          geoTaskId: taskId,
          brandProjectId: brandId,
          brand: brand,
          sentiment: fetchSentiment,
          limit: 15
        }
      });
      
      if (res.data.success && res.data.data) {
        // Map GeoResult to Drawer Format
        let realRecords = res.data.data.map(r => ({
          id: r.id,
          platform: r.engineName,
          topic: r.themeName || r.parentThemeName || '综合',
          sentiment: r.sentiment,
          brands: r.mentionedBrands ? JSON.parse(r.mentionedBrands) : [],
          productCards: r.productCards ? (typeof r.productCards === 'string' ? JSON.parse(r.productCards) : r.productCards) : [],
          xhsBrandDetails: r.xhsBrandDetails || [],
          xhsRawNotes: r.xhsRawNotes || [],
          question: r.question,
          rawResponse: (r.answer || '暂无返回结果').replace(/\>\s*.*商品卡片.*(?:(?:\r?\n)\>.*)*/g, '').trim(),
          sources: (() => {
            let arr = [];
            if (r.citations) {
              try { 
                const p = typeof r.citations === 'string' ? JSON.parse(r.citations) : r.citations;
                if (Array.isArray(p)) arr = arr.concat(p);
              } catch(e) { console.error('parse citations error', e); }
            }
            if (r.sources) {
              try { 
                const p = typeof r.sources === 'string' ? JSON.parse(r.sources) : r.sources;
                if (Array.isArray(p)) arr = arr.concat(p);
              } catch(e) { console.error('parse sources error', e); }
            }
            if (r.mediaSources && Array.isArray(r.mediaSources)) {
               arr = arr.concat(r.mediaSources);
            }
            if (r.answer) {
               const extracted = extractTrailingJSON(r.answer);
               if (extracted) arr = arr.concat(extracted.parsed);
            }
            // Remove duplicates by url
            const uniqueUrls = new Set();
            return arr.filter(s => {
                const link = s.url || s.link;
                if (link && uniqueUrls.has(link)) return false;
                if (link) uniqueUrls.add(link);
                return true;
            }).map(s => ({...s, name: s.name || s.mediaName || s.site_name || s.title || '引用来源'}));
          })(),
          time: new Date(r.createdAt || Date.now()).toLocaleString()
        }));
        
        // If we clicked on a specific 'cons' (劣势词), try to further filter locally by keyword matching in the answer
        if (cons) {
            const filtered = realRecords.filter(r => r.rawResponse.includes(cons));
            if (filtered.length > 0) {
                realRecords = filtered;
            }
        }
        
        setDrawerData(realRecords);
      } else {
        setDrawerData([]);
      }
    } catch (_err) { // eslint-disable-next-line no-unused-vars
      console.error("Failed to fetch drawer data:", err);
      setDrawerData([]);
    } finally {
      setDrawerLoading(false);
    }
  };
  
  const closeDrawer = () => setIsDrawerOpen(false);

  const handleExportImage = async () => {
    const contentElement = document.getElementById('report-content');
    if (!contentElement) return;

    try {
      const canvas = await html2canvas(contentElement, {
        scale: 2,
        useCORS: true,
        backgroundColor: document.documentElement.classList.contains('dark') ? '#0f172a' : '#ffffff'
      });
      
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `品牌数据洞察_${new Date().toISOString().slice(0, 10)}.png`;
      link.click();
    } catch (error) {
      console.error('Failed to export image', error);
    }
  };

  const handleExportExcel = () => {
    if (!dashboardData) return;

    // 1. 概览趋势与分布
    // Here we can dump competitorTable which is a summary
    const isMatrix = dashboardData.isMatrixMode;
    const summarySheetData = [
      [isMatrix ? '产品' : '品牌', '总提及数', '提及率(SOV)', '优势词汇 (Pros)', '劣势词汇 (Cons)']
    ];
    (dashboardData.competitorTable || []).forEach(row => {
      summarySheetData.push([
        row.name,
        row.mentions,
        row.sov,
        (row.pros || []).join(', '),
        (row.cons || []).join(', ')
      ]);
    });

    // 2. 情感占比 (from sentimentData)
    const sentimentSheetData = [
      ['品牌/产品', '正面评价', '中性评价', '争议评价', '负面评价']
    ];
    // sentimentData shape: labels: ['A', 'B'], datasets: [{label: '正面', data: [..]}, {label: '负面', data:[..]}]
    if (dashboardData.sentimentData && dashboardData.sentimentData.labels) {
      dashboardData.sentimentData.labels.forEach((label, idx) => {
        const row = [label];
        dashboardData.sentimentData.datasets.forEach(ds => {
          row.push(ds.data[idx]);
        });
        sentimentSheetData.push(row);
      });
    }

    // 3. 业务维度热力图 (Heatmap)
    const heatmapSheetData = [
      ['业务维度', ...(dashboardData.heatmapBrands || [])]
    ];
    (dashboardData.heatmapDimensions || []).forEach(dim => {
      const row = [dim];
      (dashboardData.heatmapBrands || []).forEach(b => {
        row.push(dashboardData.heatmapScores?.[dim]?.[b] || 0);
      });
      heatmapSheetData.push(row);
    });

    const wb = XLSX.utils.book_new();
    const wsSummary = XLSX.utils.aoa_to_sheet(summarySheetData);
    const wsSentiment = XLSX.utils.aoa_to_sheet(sentimentSheetData);
    const wsHeatmap = XLSX.utils.aoa_to_sheet(heatmapSheetData);

    // 4. SOV 趋势数据 (realSovTrend)
    const sovTrendSheetData = [];
    if (dashboardData.realSovTrend && dashboardData.realSovTrend.labels) {
      const headerRow = ['日期', ...dashboardData.realSovTrend.datasets.map(ds => ds.label)];
      sovTrendSheetData.push(headerRow);
      
      dashboardData.realSovTrend.labels.forEach((dateLabel, idx) => {
        const row = [dateLabel];
        dashboardData.realSovTrend.datasets.forEach(ds => {
          row.push(ds.data[idx]);
        });
        sovTrendSheetData.push(row);
      });
    }
    const wsSovTrend = XLSX.utils.aoa_to_sheet(sovTrendSheetData.length > 0 ? sovTrendSheetData : [['暂无数据']]);

    // 5. 竞品 SOV 占比 (sovData)
    const sovShareSheetData = [['品牌/竞品名称', 'SOV 提及率占比(%)']];
    if (dashboardData.sovData && dashboardData.sovData.labels) {
      dashboardData.sovData.labels.forEach((label, idx) => {
        const val = dashboardData.sovData.datasets[0]?.data[idx] || 0;
        sovShareSheetData.push([label, val]);
      });
    }
    const wsSovShare = XLSX.utils.aoa_to_sheet(sovShareSheetData.length > 0 ? sovShareSheetData : [['暂无数据']]);

    XLSX.utils.book_append_sheet(wb, wsSummary, "核心盘点SWOT");
    XLSX.utils.book_append_sheet(wb, wsSovShare, "竞品SOV占比");
    XLSX.utils.book_append_sheet(wb, wsSovTrend, "SOV趋势数据");
    XLSX.utils.book_append_sheet(wb, wsSentiment, "情感分布对比");
    XLSX.utils.book_append_sheet(wb, wsHeatmap, "业务维度得分");

    XLSX.writeFile(wb, `品牌数据洞察_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const renderMentionStatus = (record) => {
    if (record.sentiment === 'positive') return <span className="inline-flex items-center px-2 py-1 rounded-full bg-emerald-500/10 text-emerald-600 text-xs border border-emerald-500/20">🟢 正向评价</span>;
    if (record.sentiment === 'negative') return <span className="inline-flex items-center px-2 py-1 rounded-full bg-rose-500/10 text-rose-600 text-xs border border-rose-500/20">🔴 负向评价</span>;
    if (record.sentiment === 'controversial') return <span className="inline-flex items-center px-2 py-1 rounded-full bg-amber-500/10 text-amber-600 text-xs border border-amber-500/20">🟡 争议/多面</span>;
    return <span className="inline-flex items-center px-2 py-1 rounded-full bg-slate-500/10 text-slate-600 text-xs border border-slate-500/20">⚪ 中性客观</span>;
  };
  const engineLogos = {
  /* INJECTED_MB_PC_LOGOS_v2 */
  '豆包': '/icons/doubao.png',
  '豆包(PC)': '/icons/doubao.png',
  '豆包(MB)': '/icons/doubao.png',
  '豆包（PC）': '/icons/doubao.png',
  '豆包（MB）': '/icons/doubao.png',
  'doubao': '/icons/doubao.png',
  '腾讯元宝(PC)': '/icons/yuanbao.png',
  '腾讯元宝(MB)': '/icons/yuanbao.png',
  '腾讯元宝（PC）': '/icons/yuanbao.png',
  '腾讯元宝（MB）': '/icons/yuanbao.png',
  '通义千问': '/icons/tongyi.png',
  '通义千问(PC)': '/icons/tongyi.png',
  '通义千问(MB)': '/icons/tongyi.png',
  '通义千问（PC）': '/icons/tongyi.png',
  '通义千问（MB）': '/icons/tongyi.png',
  '通义': '/icons/tongyi.png',
  '文心一言': '/icons/wenxin.png',
  '文心一言(PC)': '/icons/wenxin.png',
  '文心一言(MB)': '/icons/wenxin.png',
  'Deepseek': '/icons/deepseek.png',
  'DeepSeek': '/icons/deepseek.png',
  'deepseek': '/icons/deepseek.png',
  'Kimi': '/icons/kimi.png',
  'kimi': '/icons/kimi.png',
  '元宝': '/icons/yuanbao.png',
  '百度AI搜索': '/icons/baidu.png',
  '小红书AI': '/icons/xiaohongshu.png',
  '抖音AI': '/icons/douyin.png',
  '小红书': '/icons/xiaohongshu.png',
  'xhs': '/icons/xiaohongshu.png',
  '微信搜一搜': '/icons/wechat.png',
  '微信': '/icons/wechat.png',
};

  
  
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [benchMain, setBenchMain] = useState('');
  const [benchComp, setBenchComp] = useState('');
  const [benchPersona, setBenchPersona] = useState("所有人群 (全局视图)");
    const [activeMediaTab, setActiveMediaTab] = useState("media");
  const [selectedBrands, setSelectedBrands] = useState([]);

  // When global brand changes, reset selected brands to empty so the new top brands can be loaded
  useEffect(() => {
    setSelectedBrands([]);
    setBenchMain('');
    setBenchComp('');
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const pid = globalProject;
        const bid = globalBrand;
        
        const res = await axios.get(`${API_URL}/dashboard/insights`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            fetchMode: localStorage.getItem('globalFetchMode') || 'hybrid',
            engines: filters.engines.includes('全部 AI 引擎') ? 'all' : filters.engines.join(','),
            stages: filters.stages.includes('全部阶段') ? 'all' : filters.stages.join(','),
            personas: activeView === 'benchmarking' ? (benchPersona === '所有人群 (全局视图)' ? 'all' : benchPersona) : (filters.personas.includes('全部人设') ? 'all' : filters.personas.join(',')),
            packages: filters.packages && !filters.packages.includes('全部词包') ? filters.packages.join(',') : 'all',
            geoTaskId: (pid === 'all' || pid === 'undefined' || !pid) ? undefined : pid,
            brandProjectId: (bid === 'all' || bid === 'undefined' || !bid) ? undefined : bid,
            viewType: activeView,
            timeRange: filters.time === '自定义时间' || filters.time === '自定义范围' ? 'custom' : filters.time,
            startDate: (() => {
              if (filters.time === '最近 7 天') {
                const start = new Date(); start.setDate(start.getDate() - 7); return start.toISOString();
              } else if (filters.time === '最近 30 天') {
                const start = new Date(); start.setDate(start.getDate() - 30); return start.toISOString();
              } else if (filters.time === '最近 90 天') {
                const start = new Date(); start.setDate(start.getDate() - 90); return start.toISOString();
              } else if (filters.time === '自定义时间' || filters.time === '自定义范围') {
                return filters.customDate.start ? new Date(filters.customDate.start).toISOString() : undefined;
              }
              return undefined;
            })(),
            endDate: (() => {
              if (filters.time === '最近 7 天' || filters.time === '最近 30 天' || filters.time === '最近 90 天') {
                return new Date().toISOString();
              } else if (filters.time === '自定义时间' || filters.time === '自定义范围') {
                if (filters.customDate.end) {
                  const end = new Date(filters.customDate.end);
                  end.setHours(23, 59, 59, 999);
                  return end.toISOString();
                }
              }
              return undefined;
            })()
          }
        });
        
                if (res.data.success && res.data.data) {
          setDashboardData(res.data.data);
          const allBrands = res.data.data.heatmapBrands || [];
          const table = res.data.data.competitorTable || [];
          let topBrands = [];
          if (table.length > 0) {
              topBrands = table.slice(0, 6).map(c => c.brand || c.name);
          } else {
              topBrands = allBrands.slice(0, 6);
          }
          
          setSelectedBrands(prev => {
             if (prev.length === 0) return topBrands;
             const hasOverlap = prev.some(b => allBrands.includes(b));
             if (!hasOverlap && allBrands.length > 0) {
                 return topBrands;
             }
             return prev;
          });
        } else {
          setDashboardData(null);
        }
      } catch (e) {
        console.error("Failed to load insights data", e);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [activeView, filters, globalProject, globalBrand, globalFetchMode]);

  const sovData = dashboardData?.sovData || { labels: [], datasets: [] };
  const radarData = dashboardData?.radarData || { labels: [], datasets: [] };
  const sentimentData = dashboardData?.sentimentData || { labels: [], datasets: [] };
  
  const heatmapDimensions = dashboardData?.heatmapDimensions || [];
    const heatmapBrands = dashboardData?.heatmapBrands || [];
  const heatmapScores = dashboardData?.heatmapScores || {};

  // Apply visual filtering for charts based on selectedBrands
  const displayBrands = selectedBrands.length > 0 
      ? heatmapBrands.filter(b => selectedBrands.includes(b)) 
      : heatmapBrands.slice(0, 6); // fallback

  const filteredRadarData = useMemo(() => {
     if (!dashboardData?.radarData) return { labels: [], datasets: [] };
     const raw = dashboardData.radarData;
     if (!selectedBrands || selectedBrands.length === 0) return raw;
     return {
        ...raw,
        datasets: raw.datasets.filter(ds => selectedBrands.includes(ds.label))
     };
  }, [dashboardData, selectedBrands]);
  const filteredSovData = useMemo(() => {
     if (!dashboardData?.sovData) return { labels: [], datasets: [] };
     const raw = dashboardData.sovData;
     if (!selectedBrands || selectedBrands.length === 0) return raw;
     const indicesToKeep = raw.labels.map((l, idx) => selectedBrands.includes(l.replace(' (本品)', '')) ? idx : -1).filter(idx => idx !== -1);
     return {
        ...raw,
        labels: raw.labels.filter((l) => selectedBrands.includes(l.replace(' (本品)', ''))),
        datasets: raw.datasets.map(ds => ({
           ...ds,
           data: ds.data.filter((_, idx) => indicesToKeep.includes(idx)),
           backgroundColor: Array.isArray(ds.backgroundColor) ? ds.backgroundColor.filter((_, idx) => indicesToKeep.includes(idx)) : ds.backgroundColor,
           borderColor: Array.isArray(ds.borderColor) ? ds.borderColor.filter((_, idx) => indicesToKeep.includes(idx)) : ds.borderColor,
        }))
     };
  }, [dashboardData, selectedBrands]);

  
  const filteredSentimentData = useMemo(() => {
     if (!dashboardData?.sentimentData) return { labels: [], datasets: [] };
     const raw = dashboardData.sentimentData;
     if (!selectedBrands || selectedBrands.length === 0) return raw;
     const indicesToKeep = raw.labels.map((l, idx) => selectedBrands.includes(l.replace(' (本品)', '')) ? idx : -1).filter(idx => idx !== -1);
     return {
        ...raw,
        labels: raw.labels.filter((l) => selectedBrands.includes(l.replace(' (本品)', ''))),
        datasets: raw.datasets.map(ds => ({
           ...ds,
           data: ds.data.filter((_, idx) => indicesToKeep.includes(idx))
        }))
     };
  }, [dashboardData, selectedBrands]);

  const filteredCompetitorTable = useMemo(() => {
     if (!dashboardData?.competitorTable) return [];
     if (!selectedBrands || selectedBrands.length === 0) return dashboardData.competitorTable;
     return dashboardData.competitorTable.filter(row => selectedBrands.includes(row.brand || row.name));
  }, [dashboardData, selectedBrands]);


  const competitorTable = dashboardData?.competitorTable || [];
  const productMappings = dashboardData?.productMappings || [];
  const isMatrixMode = dashboardData?.isMatrixMode || false;
  const wordCloudData = dashboardData?.wordCloudData || {};

  const chartSovTrend = useMemo(() => {
    const trend = dashboardData?.realSovTrend;
    if (!trend || !trend.labels) return { labels: [], datasets: [] };
    
    return {
      ...trend,
      datasets: trend.datasets.map(ds => {
        let rgba = ds.backgroundColor;
        if (rgba && rgba.startsWith('#')) {
          const r = parseInt(rgba.slice(1, 3), 16);
          const g = parseInt(rgba.slice(3, 5), 16);
          const b = parseInt(rgba.slice(5, 7), 16);
          rgba = `rgba(${r}, ${g}, ${b}, 0.2)`; // Semi-transparent for area fill
        }
        return {
          ...ds,
          fill: true,
          backgroundColor: rgba,
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 6,
          tension: 0.4 // Smooth curve
        };
      })
    };
  }, [dashboardData]);

  const chartSovTrendFiltered = useMemo(() => {
    if (!chartSovTrend || !chartSovTrend.labels) return { labels: [], datasets: [] };
    if (!selectedBrands || selectedBrands.length === 0) return chartSovTrend;
    return {
      ...chartSovTrend,
      datasets: chartSovTrend.datasets.filter(ds => selectedBrands.includes(ds.label.replace(' (本品)', '')))
    };
  }, [chartSovTrend, selectedBrands]);

  useEffect(() => {
    if (isMatrixMode && productMappings.length > 0) {
      // In product matrix mode, initialize with the first valid host product and its first valid competitor
      const validMappings = productMappings.filter(p => p.hostProduct?.trim());
      if (validMappings.length > 0) {
        const initialMain = validMappings[0].hostProduct;
        const validComps = validMappings[0].competitorProducts?.filter(cp => cp.prodName?.trim()) || [];
        const initialComp = validComps.length > 0 ? validComps[0].prodName : '';
        
        // If we don't have a selection or the current selection is invalid for the new data
        if (!benchMain || !validMappings.find(p => p.hostProduct === benchMain)) {
          setBenchMain(initialMain);
          setBenchComp(initialComp);
        }
      }
    } else if (competitorTable.length >= 2 && !benchMain && !benchComp) {
      setBenchMain(competitorTable.find(c => c.isSelf)?.brand || competitorTable[0].brand);
      setBenchComp(competitorTable.find(c => !c.isSelf)?.brand || competitorTable[1].brand);
    }
  }, [competitorTable, productMappings, isMatrixMode]);

  
  
  const sovBarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y', // horizontal bar
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function(context) {
            return context.label + ': ' + context.parsed.x + '%';
          }
        }
      }
    }
  };

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: { tension: 0.4 },
      point: { radius: 0, hitRadius: 10, hoverRadius: 6 }
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: { 
        grid: { color: 'rgba(148, 163, 184, 0.1)', borderDash: [4, 4] }, 
        ticks: { color: '#94a3b8' } 
      },
      y: { 
        min: 0,
        max: 100,
        grid: { color: 'rgba(148, 163, 184, 0.1)', borderDash: [4, 4] }, 
        ticks: { 
          color: '#64748b',
          callback: function(value) { return value + '%'; }
        } 
      }
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          boxWidth: 6,
          boxHeight: 6,
          color: '#94a3b8',
          font: { family: 'Inter, sans-serif', size: 12 }
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function(context) {
            return context.dataset.label + ': ' + context.parsed.y + '%';
          }
        }
      }
    }
  };


  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'right', labels: { color: '#94a3b8', font: { family: 'Inter, sans-serif', size: 12 } } },
      tooltip: {
        callbacks: {
          label: function(context) {
            const val = context.parsed;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const pct = total > 0 ? Math.round((val / total) * 100) : 0;
            return context.label + ': ' + val + ' (' + pct + '%)';
          }
        }
      }
    }
  };

    const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (evt, elements) => {
      if (elements.length > 0) {
        const datasetIndex = elements[0].datasetIndex;
        const index = elements[0].index;
        const brand = sentimentData.labels[index];
        const sentimentType = sentimentData.datasets[datasetIndex].label; // e.g. "正面(Positive)"
        if (sentimentType.includes("负向") || sentimentType.includes("负面")) {
           openEvidenceDrawer(`🔍 【${brand}】负向评价溯源明细`, { brand, sentiment: 'negative' });
        } else if (sentimentType.includes("正向") || sentimentType.includes("好评")) {
           openEvidenceDrawer(`🔍 【${brand}】正向评价溯源明细`, { brand, sentiment: 'positive' });
        } else if (sentimentType.includes("争议") || sentimentType.includes("参半") || sentimentType.includes("多面")) {
           openEvidenceDrawer(`🔍 【${brand}】争议评价溯源明细`, { brand, sentiment: 'controversial' });
        } else {
           openEvidenceDrawer(`🔍 【${brand}】中性评价溯源明细`, { brand, sentiment: 'neutral' });
        }
      }
    },
    scales: {
      x: { stacked: true, grid: { display: false }, ticks: { color: '#94a3b8' } },
      y: { stacked: true, grid: { color: 'rgba(148, 163, 184, 0.1)' }, ticks: { color: '#94a3b8' } }
    },
    plugins: {
      legend: { position: 'top', labels: { color: '#94a3b8' } },
      tooltip: {
        callbacks: {
          footer: () => '👉 点击查看证据溯源'
        }
      }
    }
  };

  
  const defaultPieData = {
    labels: ['暂无数据'],
    datasets: [{
      data: [1],
      backgroundColor: ['rgba(200, 200, 200, 0.2)'],
      borderColor: ['#fff'],
      borderWidth: 1,
    }]
  };

  const radarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        angleLines: { color: 'rgba(148, 163, 184, 0.2)' },
        grid: { color: 'rgba(148, 163, 184, 0.2)' },
        pointLabels: { color: '#94a3b8', font: { size: 11 } },
        ticks: { display: false, min: 0, max: 100 }
      }
    },
    plugins: {
      legend: { position: 'bottom', labels: { color: '#94a3b8' } },
      tooltip: {
        callbacks: {
          label: function(context) {
            return context.dataset.label + ': ' + context.parsed.r + '%';
          }
        }
      }
    }
  };

  const getHeatmapColor = (score) => {
    if (score >= 90) return 'bg-[#2996cf] text-white';
    if (score >= 80) return 'bg-[#0ea5e9] text-white';
    if (score >= 70) return 'bg-sky-400 text-white';
    if (score >= 60) return 'bg-sky-300 text-slate-800';
    if (score >= 40) return 'bg-sky-200 text-slate-800';
    return 'bg-slate-100 dark:bg-slate-700 text-slate-400';
  };

  
  const exportDimensionData = async () => {
    try {
      const token = localStorage.getItem('token');
      const pid = globalProject;
      const bid = globalBrand;
      
      const res = await axios.get(`${API_URL}/results`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          brandProjectId: (bid === 'all' || bid === 'undefined' || !bid) ? undefined : bid,
          geoTaskId: (pid === 'all' || pid === 'undefined' || !pid) ? undefined : pid,
          limit: 10000,
          status: 'analyzed',
          engines: filters.engines.includes('全部 AI 引擎') ? 'all' : filters.engines.join(','),
          personas: activeView === '产品对标矩阵' ? (benchPersona === '所有人群 (全局视图)' ? 'all' : benchPersona) : (filters.personas.includes('全部人设') ? 'all' : filters.personas.join(','))
        }
      });
      
      if (res.data.success) {
        const data = res.data.data || [];
        const exportData = data.map(r => {
            let cleanedQuestion = r.question || '';
            const m = cleanedQuestion.match(/解答以下问题或给出推荐：(.*?)(?:？*求真实的建议！)?$/);
            if (m) {
                cleanedQuestion = m[1].replace(/？*求真实的建议！$/, '').trim();
            } else {
                cleanedQuestion = cleanedQuestion.replace(/.*解答以下问题或给出推荐：/, '').replace(/？*求真实的建议！$/, '').trim();
            }
            cleanedQuestion = cleanedQuestion.replace(/^[：:\s]+/, '');
            
            let cleanAnswer = (r.answer || '').replace(/\>\s*.*商品卡片.*(?:(?:\r?\n)\>.*)*/g, '').trim();
            cleanAnswer = cleanAnswer.replace(/```json[\s\S]*?```/g, '');
            cleanAnswer = cleanAnswer.replace(/\[\s*\{[\s\S]*\}\s*\]\s*$/, '');
            cleanAnswer = cleanAnswer.trim();
            
            return {
                '十维度': r.themeName || r.parentThemeName || '未分类',
                '关键词': cleanedQuestion,
                'AI的回答': cleanAnswer.length > 32700 ? cleanAnswer.substring(0, 32700) + '...[已截断]' : cleanAnswer,
                'AI引擎': r.engineName
            };
        });
        
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "十维度回答");
        XLSX.writeFile(workbook, `十维度源数据_${new Date().getTime()}.xlsx`);
      }
    } catch (e) {
      console.error(e);
      alert('下载失败，请稍后再试');
    }
  };

  const exportSourcesData = async () => {
    try {
      const token = localStorage.getItem('token');
      const pid = globalProject;
      const bid = globalBrand;
      
      const res = await axios.get(`${API_URL}/results`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          brandProjectId: (bid === 'all' || bid === 'undefined' || !bid) ? undefined : bid,
          geoTaskId: (pid === 'all' || pid === 'undefined' || !pid) ? undefined : pid,
          system: 'geo',
          limit: 10000
        }
      });
      
      if (res.data && res.data.success) {
        let exportData = [];
        res.data.data.forEach(r => {
            
            let cleanedQuestion = (r.question || '').replace(/^在?小红书上?搜索[s"“”：:]*/, '').replace(/["“”]$/, '');
            cleanedQuestion = cleanedQuestion.replace(/^[：:\s]+/, '');
            
            const isXhs = r.engineName && (r.engineName.toLowerCase().includes('xhs') || r.engineName.includes('小红书'));
            
            if (isXhs && (r.xhsRawNotes?.length > 0 || r.sources)) {
                // AIO Notes
                if (r.xhsRawNotes && r.xhsRawNotes.length > 0) {
                    r.xhsRawNotes.forEach((n, idx) => {
                        exportData.push({
                            '十维度': r.themeName || r.parentThemeName || '未分类',
                            'Prompt词': cleanedQuestion,
                            '数据类型 (Scope)': 'AIO引用文章',
                            '信源媒体名字': n.nickname || '小红书用户',
                            '博主名字': n.nickname || '-',
                            '文章标题': n.title || '-',
                            '文章描述': n.content || '-',
                            '点赞数': n.likeCount || 0,
                            '收藏数': n.collectCount || 0,
                            '评论数': n.commentCount || 0,
                            '转发数': n.shareCount || 0,
                            '信源网址': (n.noteUrl && n.noteUrl !== 'about:blank') ? n.noteUrl : '-',
                            '信源分类': 'AIO引用溯源',
                            'AI引擎': r.engineName
                        });
                    });
                }
                
                // Organic Notes
                let parsedSources = [];
                try {
                    parsedSources = r.sources ? (typeof r.sources === 'string' ? JSON.parse(r.sources) : r.sources) : [];
                } catch(e) {}
                
                if (parsedSources && parsedSources.length > 0) {
                    parsedSources.forEach((s, idx) => {
                        exportData.push({
                            '十维度': r.themeName || r.parentThemeName || '未分类',
                            'Prompt词': cleanedQuestion,
                            '数据类型 (Scope)': '自然排名笔记',
                            '信源媒体名字': s.name || s.mediaName || s.nickname || '-',
                            '博主名字': s.nickname || s.name || s.mediaName || '-',
                            '文章标题': s.title || '-',
                            '文章描述': s.snippet || '-',
                            '点赞数': s.likeCount || 0,
                            '收藏数': s.collectCount || 0,
                            '评论数': s.commentCount || 0,
                            '转发数': s.shareCount || 0,
                            '信源网址': (s.url && s.url !== 'about:blank') ? s.url : '-',
                            '信源分类': '自然排名结果',
                            'AI引擎': r.engineName
                        });
                    });
                }
                return;
            }

            let sourcesList = [];
            try {
                if (r.sources) {
                    const parsed = JSON.parse(r.sources);
                    if (Array.isArray(parsed)) sourcesList = sourcesList.concat(parsed);
                }
                if (r.citations) {
                    const parsed = JSON.parse(r.citations);
                    if (Array.isArray(parsed)) sourcesList = sourcesList.concat(parsed);
                }
            } catch(e) {}
            
            const fType = (r.funnelStage || 'awareness').toLowerCase();
            const typeMapping = {
                'sense': '资讯快讯',
                'interest': '科普指南',
                'connection': '客观测评/横评',
                'action': '用户真实体验',
                'share': '用户避坑/吐槽',
                'awareness': '资讯快讯',
                'consideration': '客观测评/横评',
                'decision': '导购推荐',
                'advocacy': '用户真实体验'
            };
            const articleType = typeMapping[fType] || '新闻通稿/科普';
            
            if (sourcesList.length === 0) {
                exportData.push({
                  '十维度': r.themeName || r.parentThemeName || '未分类',
                  'Prompt词': cleanedQuestion,
                  '数据类型 (Scope)': '-',
                  '信源媒体名字': '-',
                  '博主名字': '-',
                  '文章标题': '-',
                  '文章描述': '-',
                  '点赞数': '-',
                  '收藏数': '-',
                  '评论数': '-',
                  '转发数': '-',
                  '信源网址': '-',
                  '信源分类': articleType,
                  'AI引擎': r.engineName
                });
                return;
            }
            
            sourcesList.forEach(s => {
              let platform = s.platform || s.name || s.mediaName || '未知来源';
              if (platform !== '未知来源') {
                  platform = platform.replace(/-.*/, '').trim();
              }
              
              exportData.push({
                  '十维度': r.themeName || r.parentThemeName || '未分类',
                  'Prompt词': cleanedQuestion,
                  '数据类型 (Scope)': '通用信源引用',
                  '信源媒体名字': platform,
                  '博主名字': '-',
                  '文章标题': s.title || '-',
                  '文章描述': s.snippet || '-',
                  '点赞数': '-',
                  '收藏数': '-',
                  '评论数': '-',
                  '转发数': '-',
                  '信源网址': s.url || s.link || '#',
                  '信源分类': articleType,
                  'AI引擎': r.engineName
              });
            });
        });
        
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "信源明细");
        XLSX.writeFile(workbook, `信源引用源数据_${new Date().getTime()}.xlsx`);
      }
    } catch (e) {
      console.error(e);
      alert('下载失败，请稍后再试');
    }
  };

  return (
    <ErrorBoundary>
      <div className="space-y-6 max-w-full p-2">
            <div className="flex justify-between items-end">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100 flex items-center space-x-4">
            <span>品牌数据洞察</span>
            <div className="flex bg-slate-100 dark:bg-slate-800 rounded-lg p-1 text-sm font-normal">
              <button 
                onClick={() => setActiveView('global')}
                className={`px-4 py-1.5 rounded-md transition-all ${activeView === 'global' ? 'bg-white dark:bg-slate-700 text-[#2996cf] shadow-sm font-semibold' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
              >
                品牌全景大盘
              </button>
              <button 
                onClick={() => setActiveView('benchmarking')}
                className={`px-4 py-1.5 rounded-md transition-all flex items-center ${activeView === 'benchmarking' ? 'bg-white dark:bg-slate-700 text-[#2996cf] shadow-sm font-semibold' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
              >
                <Target className="w-4 h-4 mr-1.5" />
                产品对标矩阵
              </button>
              <button 
                onClick={() => setActiveView('persona')}
                className={`px-4 py-1.5 rounded-md transition-all flex items-center ${activeView === 'persona' ? 'bg-white dark:bg-slate-700 text-[#2996cf] shadow-sm font-semibold' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
              >
                <Users className="w-4 h-4 mr-1.5" />
                人群圈层差异洞察
              </button>
              {globalProject === '210' && (
                <button 
                  onClick={() => setActiveView('strategic')}
                  className={`px-4 py-1.5 rounded-md transition-all flex items-center ${activeView === 'strategic' ? 'bg-white dark:bg-slate-700 text-[#2996cf] shadow-sm font-semibold' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
                >
                  <FileText className="w-4 h-4 mr-1.5" />
                  战略研报
                </button>
              )}
            </div>
          </h2>
          <p className="text-gray-500 dark:text-slate-400 mt-2">
            多维度分析品牌在各大AI引擎中的舆情表现与人设感知。
          </p>
        </div>
        <div className="flex items-center gap-3">

          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#8B84AD] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportExcel}
          >
            <FileSpreadsheet className="w-4 h-4" />
            导出数据
          </button>
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#9EA9DF] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportImage}
          >
            <Download className="w-4 h-4" />
            导出图片
          </button>
        </div>
      </div>

            {/* Global Filter Bar */}
      <div ref={filterBarRef} className="relative z-40 bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-lg p-3 mb-6 flex flex-wrap items-center gap-3 shadow-sm">
        <div className="flex items-center text-sm font-medium text-gray-700 dark:text-slate-300 mr-2">
          <Filter size={16} className="mr-2 text-blue-500" /> 数据筛选
        </div>
        
        {/* Time Filter */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('time')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <Calendar size={14} />
            <span>{filters.time === '自定义范围' && filters.customDate.start ? `${filters.customDate.start} 至 ${filters.customDate.end}` : filters.time}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'time' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'time' && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              {['最近 7 天', '最近 30 天', '最近 90 天', '全部时间', '自定义范围'].map(opt => (
                <div key={opt} onClick={() => updateTimeFilter(opt)} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex justify-between items-center">
                  <span>{opt}</span>
                  {filters.time === opt && <Check size={14} className="text-blue-500" />}
                </div>
              ))}
              {filters.time === '自定义范围' && (
                <div className="px-4 py-3 bg-gray-50 dark:bg-slate-900/50 border-t border-gray-100 dark:border-slate-700 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">开始</span>
                    <input type="date" value={filters.customDate.start} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, start: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">结束</span>
                    <input type="date" value={filters.customDate.end} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, end: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <button onClick={() => setOpenDropdown(null)} className="w-full mt-2 bg-blue-500 text-white text-xs py-1.5 rounded hover:bg-blue-600 transition">确定</button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* AI Platform Filter (Multi-select) */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('engines')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.engines, '全部 AI 引擎')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'engines' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'engines' && (
            <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="py-1">
                <div onClick={() => toggleArrayFilter('engines', '全部 AI 引擎', '全部 AI 引擎')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2 font-medium">
                  <input type="checkbox" checked={filters.engines.includes('全部 AI 引擎')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span>全部 AI 引擎</span>
                </div>
                
                {['Kimi', 'DeepSeek', '豆包', '文心一言', '腾讯元宝', '通义千问', '小红书AI', '抖音AI', '百度AI搜索'].map(opt => {
                  const isDisabled = opt === '百度AI搜索';
                  if (opt === '豆包' || opt === '腾讯元宝' || opt === '通义千问') {
                     const baseName = opt;
                     const pcName = baseName + '(PC)';
                     const mbName = baseName + '(MB)';
                     const isMBDisabled = false; 
                     
                     return (
                        <div key={opt} className="px-4 py-2 flex flex-col gap-2 border-b border-gray-50 dark:border-slate-800/50 hover:bg-gray-50/50 dark:hover:bg-slate-700/50">
                           <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-300">
                              {engineLogos[baseName] && <img src={engineLogos[baseName]} alt={baseName} className="w-4 h-4 rounded-sm object-contain" />}
                              <span>{baseName}</span>
                           </div>
                           <div className="flex gap-2 pl-6">
                              <div onClick={(e) => { e.stopPropagation(); toggleArrayFilter('engines', pcName, '全部 AI 引擎') }} className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs cursor-pointer transition-colors border ${filters.engines.includes(pcName) ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                 <span>PC</span>
                              </div>
                              <div onClick={(e) => { 
                                  e.stopPropagation(); 
                                  if (!isMBDisabled) toggleArrayFilter('engines', mbName, '全部 AI 引擎'); 
                                }} 
                                className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors border ${isMBDisabled ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed dark:bg-slate-800/50 dark:border-slate-700 dark:text-slate-500' : (filters.engines.includes(mbName) ? 'bg-blue-50 border-blue-200 text-blue-700 cursor-pointer dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 cursor-pointer hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700')}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
                                 <span>MB</span>
                              </div>
                           </div>
                        </div>
                     );
                  }
                  return (
                  <div 
                    key={opt} 
                    onClick={(e) => { e.stopPropagation(); if (!isDisabled) toggleArrayFilter('engines', opt, '全部 AI 引擎') }} 
                    className={`px-4 py-2 text-sm flex items-center space-x-2 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-50 dark:bg-slate-900 text-gray-500' : 'text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer'}`}
                    title={isDisabled ? "暂未开放" : ""}
                  >
                    <input type="checkbox" checked={filters.engines.includes(opt)} disabled={isDisabled} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" />
                    {engineLogos[opt] && <img src={engineLogos[opt]} alt={opt} className="w-4 h-4 rounded-sm object-contain" />}
                    <span>{opt}{isDisabled ? ' (暂未开放)' : ''}</span>
                  </div>
                  );
                })}

              </div>
            </div>
          )}
        </div>
        
        {/* Intent Filter */}
        <div className="relative">
          <button onClick={() => toggleDropdown('stages')} className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors">
            <span>{renderArrayLabel(filters.stages, '全部阶段', '意图: ')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'stages' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'stages' && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700 flex justify-between">
                <span>GEO 4A 漏斗 (可多选)</span>
              </div>
              <div onClick={() => toggleArrayFilter('stages', '全部阶段', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2 font-medium">
                <input type="checkbox" checked={filters.stages.includes('全部阶段')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <span>全部阶段</span>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Aware', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-start space-x-2">
                <input type="checkbox" checked={filters.stages.includes('Aware')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium">Aware (认知发现)</div>
                  <div className="text-[10px] text-gray-400">泛搜索，不知道具体品牌</div>
                </div>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Appeal', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-start space-x-2">
                 <input type="checkbox" checked={filters.stages.includes('Appeal')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium">Appeal (兴趣探索)</div>
                  <div className="text-[10px] text-gray-400">对品牌有印象，了解情况</div>
                </div>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Ask', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer bg-blue-50/30 flex items-start space-x-2">
                <input type="checkbox" checked={filters.stages.includes('Ask')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium flex items-center">
                    Ask (对比问询)
                    <span className="ml-2 text-[9px] bg-blue-100 text-blue-600 px-1 py-0.5 rounded border border-blue-200">防守核心</span>
                  </div>
                  <div className="text-[10px] text-gray-400">核心竞品对比与购买决策</div>
                </div>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Action', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-start space-x-2">
                <input type="checkbox" checked={filters.stages.includes('Action')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium">Action (转化行动)</div>
                  <div className="text-[10px] text-gray-400">寻找购买渠道与售后服务</div>
                </div>
              </div>
            </div>
          )}
        </div>

                {/* Packages Filter */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('packages')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.packages, '全部词包', '词包: ')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'packages' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'packages' && (
            <div className="absolute top-full left-0 mt-1 w-56 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden max-h-64 overflow-y-auto">
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700 flex justify-between">
                  <span>选择词包 (可多选)</span>
                </div>
                {projectPackages.map(opt => {
                  const isSelected = filters.packages && filters.packages.includes(opt);
                  return (
                    <div key={opt} onClick={() => toggleArrayFilter('packages', opt, '全部词包')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2">
                      <input type="checkbox" checked={isSelected} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                      <span className="truncate">{opt}</span>
                    </div>
                  );
                })}
            </div>
          )}
        </div>

        {/* Personas Filter */}
        <div className="relative">
          <button onClick={() => toggleDropdown('personas')} className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors">
            <span>{renderArrayLabel(filters.personas, '全部人设', '人设: ')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'personas' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'personas' && (
            <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700">可多选</div>
              <div className="py-1">
                {projectPersonas.map(opt => (
                  <div key={opt} onClick={() => toggleArrayFilter('personas', opt, '全部人设')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2">
                    <input type="checkbox" checked={filters.personas.includes(opt)} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                    <span>{opt}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div id="report-content" className="space-y-6 pt-2 pb-4 px-1 bg-transparent">
      {!dashboardData && !loading ? (
        <div className="flex flex-col items-center justify-center h-64 text-slate-500 bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700">
          <svg className="w-12 h-12 text-slate-300 dark:text-slate-600 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          请先在顶部选择品牌与项目
        </div>
      ) : (
        <>
          <div className={`transition-all duration-300 ${loading ? 'opacity-50 pointer-events-none blur-[2px]' : ''}`}>
          {activeView === 'global' ? (
        <>
          {/* Brand Filter for Charts */}
          <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-4 shadow-sm mb-6 flex items-center justify-between flex-wrap gap-4">
             <div className="flex items-center gap-3 flex-wrap">
                <div className="flex flex-col gap-3 w-full">
               {/* Line 1: Pre-configured competitors */}
               <div className="flex items-start gap-3">
                  <span className="text-sm font-medium text-gray-700 dark:text-slate-300 whitespace-nowrap mt-1">核心设定竞品:</span>
                  <div className="flex flex-wrap gap-2">
                     {[...new Set(heatmapBrands)].filter(b => !(dashboardData?.aiDiscoveredBrands || []).includes(b)).map(b => {
                        if (!b ) return null;
                        const isSelected = selectedBrands.includes(b);
                        return (
                           <label key={b} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-colors border ${isSelected ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/30 dark:border-blue-800/50 dark:text-blue-400' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700'}`}>
                              <input 
                                 type="checkbox" 
                                 className="sr-only" 
                                 checked={isSelected}
                                 onChange={() => {
                                    if (isSelected && selectedBrands.length > 1) {
                                       setSelectedBrands(selectedBrands.filter(sb => sb !== b));
                                    } else if (!isSelected && selectedBrands.length < 8) {
                                       setSelectedBrands([...selectedBrands, b]);
                                    } else if (!isSelected && selectedBrands.length >= 8) {
                                       alert('为了保证图表可读性，最多只能同时选中 8 个品牌进行对比哦。');
                                    }
                                 }}
                              />
                              {isSelected && <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>}
                              {b}
                           </label>
                        )
                     })}
                  </div>
               </div>

               {/* Line 2: AI Discovered Brands */}
               {dashboardData?.aiDiscoveredBrands !== undefined && (
                  <div className="flex items-start gap-3 border-t border-gray-100 dark:border-slate-700/50 pt-3">
                     <span className="text-sm font-medium text-emerald-600 dark:text-emerald-400 whitespace-nowrap mt-1 flex items-center gap-1">
                        <Sparkles className="w-4 h-4" />
                        AI 挖掘竞品:
                     </span>
                     <div className="flex flex-wrap gap-2">
                     {dashboardData?.aiDiscoveredBrands?.length === 0 && (
                        <span className="text-xs text-gray-400 dark:text-slate-500 mt-1">本周期内暂无新发现的竞品</span>
                     )}
                     {dashboardData?.aiDiscoveredBrands?.map(b => {
                           if (!b) return null;
                           const isSelected = selectedBrands.includes(b);
                           return (
                              <label key={b} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-colors border ${isSelected ? 'bg-emerald-50 border-emerald-200 text-emerald-700 dark:bg-emerald-900/30 dark:border-emerald-800/50 dark:text-emerald-400' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700'}`}>
                                 <input 
                                    type="checkbox" 
                                    className="sr-only" 
                                    checked={isSelected}
                                    onChange={() => {
                                       if (isSelected && selectedBrands.length > 1) {
                                          setSelectedBrands(selectedBrands.filter(sb => sb !== b));
                                       } else if (!isSelected && selectedBrands.length < 8) {
                                          setSelectedBrands([...selectedBrands, b]);
                                       } else if (!isSelected && selectedBrands.length >= 8) {
                                          alert('为了保证图表可读性，最多只能同时选中 8 个品牌进行对比哦。');
                                       }
                                    }}
                                 />
                                 {isSelected && <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>}
                                 {b}
                              </label>
                           )
                        })}
                     </div>
                  </div>
               )}
            </div>
             </div>
             <div className="text-xs text-slate-400">取消勾选可隐藏拥挤的线条</div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm lg:col-span-1">
              <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4">SOV 提及率 (Share of Voice)</h3>
              <div className="h-64"><Bar data={filteredSovData} options={sovBarOptions} /></div>
            </div>
            <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm lg:col-span-2">
              <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4">SOV 份额攻防走势 (Trend Over Time)</h3>
              <div className="h-64">
                {chartSovTrend?.labels?.length > 0 ? (
                  <Line data={chartSovTrendFiltered} options={lineOptions} />
                ) : (
                  <div className="flex h-full items-center justify-center text-slate-400 text-sm">
                    暂无足够的历史趋势数据
                  </div>
                )}
              </div>
            </div>
          </div>

          
          

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
            <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
              <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4">能力维度透视 (Capability Profile)</h3>
              <div className="h-64"><Radar data={filteredRadarData} options={radarOptions} /></div>
            </div>
            <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
              <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4">情感倾向对比 (Sentiment Comparison)</h3>
              <div className="h-64"><Bar data={filteredSentimentData} options={barOptions} /></div>
            </div>
          </div>
          
          
          

          <div className="mt-6 border border-gray-200 dark:border-slate-700/50 rounded-xl bg-white dark:bg-slate-800/50 backdrop-blur-xl shadow-sm overflow-hidden">
            <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="font-semibold text-gray-900 dark:text-slate-200 flex items-center gap-2">
                    <span className="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                    媒体偏好分析
                  </h3>
                  <div className="flex items-center gap-3">
                    <div className="flex bg-gray-100 dark:bg-slate-700/50 p-0.5 rounded-lg text-xs font-medium">
                      <button 
                        onClick={() => setActiveMediaTab('media')}
                        className={`px-3 py-1 rounded-md transition-colors ${activeMediaTab === 'media' ? 'bg-white dark:bg-slate-600 shadow-sm text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`}
                      >具体媒体</button>
                      <button 
                        onClick={() => setActiveMediaTab('type')}
                        className={`px-3 py-1 rounded-md transition-colors ${activeMediaTab === 'type' ? 'bg-white dark:bg-slate-600 shadow-sm text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`}
                      >信源分类</button>
                    </div>
                    <button 
                      onClick={() => openMediaEvidenceDrawer('📊 媒体与内容溯源明细')}
                      className="text-xs flex items-center gap-1 text-blue-600 dark:text-blue-400 hover:text-blue-700 bg-blue-50 dark:bg-blue-900/30 px-3 py-1.5 rounded-md transition-colors"
                    >
                      <Search className="w-3.5 h-3.5" />
                      查看明细
                    </button>
                  </div>
                </div>
                <div className="h-64">
                    {activeMediaTab === 'media' ? (
                        <Doughnut data={dashboardData?.mediaPrefData?.[activeEngineTab] || defaultPieData} options={chartOptions} />
                    ) : (
                        <Doughnut data={dashboardData?.mediaTypePrefData?.[activeEngineTab] || defaultPieData} options={chartOptions} />
                    )}
                </div>
              </div>
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="font-semibold text-gray-900 dark:text-slate-200 flex items-center gap-2">
                    <span className="w-1.5 h-4 bg-purple-500 rounded-full"></span>
                    内容类型构成 (Article Types)
                  </h3>
                  <button 
                    onClick={() => openMediaEvidenceDrawer('📊 媒体与内容溯源明细')}
                    className="text-xs flex items-center gap-1 text-purple-600 dark:text-purple-400 hover:text-purple-700 bg-purple-50 dark:bg-purple-900/30 px-3 py-1.5 rounded-md transition-colors"
                  >
                    <Search className="w-3.5 h-3.5" />
                    查看明细 & 导出
                  </button>
                </div>
                <div className="h-64"><Doughnut data={dashboardData?.articleTypeData?.[activeEngineTab] || defaultPieData} options={chartOptions} /></div>
              </div>
            </div>
          </div>






          
          {/* AI Cognitive Word Cloud */}
          {dashboardData && Object.keys(wordCloudData).length > 0 && heatmapBrands.length > 0 && (
            <div className="mt-6">
              <WordCloudCard 
                data={wordCloudData} 
                brands={heatmapBrands} 
                onWordClick={(theme, sentiment, brand) => {
                  let sentimentLabel = sentiment === 'positive' ? '正向评价' : sentiment === 'negative' ? '负向评价' : '中性客观';
                  openEvidenceDrawer(`🔍 【${brand}】${theme} (${sentimentLabel}) 溯源明细`, { brand, theme, sentiment });
                }} 
              />
            </div>
          )}

          <div className="mt-6 bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm overflow-x-auto">
            <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4">AI 认知热力图 (Semantic Heatmap)</h3>
            <div className="min-w-[800px]">
              <div className="grid gap-1 mb-2" style={{ gridTemplateColumns: `140px repeat(${Math.max(1, heatmapDimensions.length)}, minmax(0, 1fr))` }}>
                <div className="text-xs font-medium text-slate-400 flex items-end pb-2">品牌 \\ 维度</div>
                {heatmapDimensions.map(dim => (
                  <div key={dim} className="text-[11px] font-medium text-slate-500 dark:text-slate-400 text-center pb-2 break-words leading-tight flex items-end justify-center">
                    <span className="px-2 text-center break-words">{dim}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-col gap-1">
                {[...new Set(displayBrands.filter(b => b && typeof b === 'string' && b.trim() !== ''))].map(brand => (
                  <div key={brand} className="grid gap-1" style={{ gridTemplateColumns: `140px repeat(${Math.max(1, heatmapDimensions.length)}, minmax(0, 1fr))` }}>
                    <div className="text-sm font-medium text-slate-700 dark:text-slate-300 flex items-center">{brand || '未命名'}</div>
                    {heatmapScores[brand]?.map((score, idx) => (
                      <div key={idx} className={`h-10 rounded flex items-center justify-center text-xs font-medium transition-colors ${getHeatmapColor(score)}`} title={`${brand} - ${heatmapDimensions[idx]}: ${score}%`}>
                        {score}%
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-6 bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm overflow-x-auto">
            <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4">{dashboardData?.isMatrixMode ? '产品核心盘点 (Product Summary)' : '竞品核心盘点 (Competitor Summary)'}</h3>
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-gray-200 dark:border-slate-700 text-sm text-slate-500">
                  <th className="pb-3 pl-2 font-medium">{dashboardData?.isMatrixMode ? '产品' : '品牌'}</th>
                  <th className="pb-3 font-medium">SOV 提及率</th>
                  <th className="pb-3 font-medium">最高频上榜引擎</th>
                  <th className="pb-3 font-medium">引擎渗透率</th>
                  <th className="pb-3 font-medium">综合好感度</th>
                  <th className="pb-3 font-medium text-left" style={{ color: "#60aa84" }}>核心优势 (Pros)</th>
                  <th className="pb-3 font-medium text-left" style={{ color: "#f5666d" }}>核心劣势 (Cons)</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {filteredCompetitorTable.map((item, idx) => (
                  <tr key={idx} className={`border-b border-gray-100 dark:border-slate-700/50 last:border-0 hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-colors ${item.isSelf ? 'bg-sky-50/50 dark:bg-sky-900/10' : ''}`}>
                    <td className="py-3 pl-2">
                      <div className="flex items-center space-x-2">
                        {item.isSelf && <div className="w-1.5 h-1.5 rounded-full bg-[#2996cf]"></div>}
                        <span className={`font-medium ${item.isSelf ? 'text-[#2996cf] dark:text-sky-400' : 'text-gray-700 dark:text-slate-300'}`}>
                          {item.brand} {item.isSelf && <span className="text-xs text-[#2996cf] bg-sky-100 dark:bg-sky-900/40 px-1.5 py-0.5 rounded ml-1">本品</span>}
                        </span>
                      </div>
                    </td>
                    <td className="py-3 font-semibold text-gray-900 dark:text-slate-200">{item.sov}</td>
                    <td className="py-3 text-gray-600 dark:text-slate-400">
                      <span className="px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded text-xs">{item.topEngineName}</span>
                    </td>
                    <td className="py-3 text-gray-600 dark:text-slate-400">{item.topEngineShare}</td>
                    <td className="py-3">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        parseInt(item.recommendRate) >= 80 ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' :
                        parseInt(item.recommendRate) >= 60 ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' :
                        'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400'
                      }`}>
                        {item.recommendRate}
                      </span>
                    </td>
                    <td className="py-3">
                      <div className="flex flex-wrap gap-1">
                        {item.pros?.map((pro, i) => (
                          <span 
                            key={i} 
                            onClick={() => openEvidenceDrawer(`🔍 【${item.brand}】核心优势 (${pro}) 原始对话`, { brand: item.brand, pros: pro })}
                            className="px-2 py-1 rounded text-xs border hover:underline cursor-pointer transition-colors"
                            style={{ backgroundColor: "#60aa841a", color: "#60aa84", borderColor: "#60aa8433" }}
                            title="点击查看优势溯源"
                          >
                            {pro}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="py-3">
                      <div className="flex flex-wrap gap-1">
                        {item.cons?.map((con, i) => (
                          <span 
                            key={i} 
                            onClick={() => openEvidenceDrawer(`🔍 【${item.brand}】核心劣势 (${con}) 原始对话`, { brand: item.brand, cons: con })}
                            className="px-2 py-1 rounded text-xs border hover:underline cursor-pointer transition-colors"
                            style={{ backgroundColor: "#f5666d1a", color: "#f5666d", borderColor: "#f5666d33" }}
                            title="点击查看劣势溯源"
                          >
                            {con}
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : activeView === 'benchmarking' ? (
        <div className="space-y-6">
          {/* Benchmarking View Implementation */}
          <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm mb-6">
            <div className="flex flex-col md:flex-row gap-4 items-center">
              <div className="flex-1 flex items-center space-x-3 w-full">
                <div className="text-sm font-semibold text-gray-500 dark:text-slate-400 w-16 shrink-0">{dashboardData?.isMatrixMode ? '主推产品' : '主推品牌'}</div>
                <select 
                  className="flex-1 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg px-4 py-2.5 text-sm font-medium text-gray-800 dark:text-slate-200 focus:outline-none focus:border-[#2996cf]"
                  value={benchMain}
                  onChange={e => {
                    const newMain = e.target.value;
                    setBenchMain(newMain);
                    if (isMatrixMode) {
                      const mapping = productMappings.find(p => p.hostProduct === newMain);
                      const validComps = mapping?.competitorProducts?.filter(cp => cp.prodName?.trim()) || [];
                      if (validComps.length > 0) {
                        setBenchComp(validComps[0].prodName);
                      }
                    }
                  }}
                >
                  {isMatrixMode 
                    ? productMappings.filter(p => p.hostProduct?.trim()).map(p => <option key={p.hostProduct} value={p.hostProduct}>{p.hostProduct}</option>)
                    : competitorTable.map(c => <option key={c.brand} value={c.brand}>{c.brand} {c.isSelf ? '(本品)' : ''}</option>)
                  }
                </select>
              </div>
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-rose-50 dark:bg-rose-900/20 text-rose-500 font-bold shrink-0 text-xs">VS</div>
              <div className="flex-1 flex items-center space-x-3 w-full">
                <div className="text-sm font-semibold text-gray-500 dark:text-slate-400 w-16 shrink-0">{dashboardData?.isMatrixMode ? '对标产品' : '对标竞品'}</div>
                <select 
                  className="flex-1 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg px-4 py-2.5 text-sm font-medium text-gray-800 dark:text-slate-200 focus:outline-none focus:border-rose-400"
                  value={benchComp}
                  onChange={e => setBenchComp(e.target.value)}
                >
                  {isMatrixMode
                    ? (productMappings.find(p => p.hostProduct === benchMain)?.competitorProducts || []).filter(cp => cp.prodName?.trim()).map(cp => <option key={cp.prodName} value={cp.prodName}>{cp.prodName}</option>)
                    : competitorTable.map(c => <option key={c.brand} value={c.brand}>{c.brand}</option>)
                  }
                </select>
              </div>
              <div className="w-px h-10 bg-gray-200 dark:bg-slate-700 mx-2 hidden md:block"></div>
              <div className="flex-1 flex items-center space-x-3 w-full">
                <div className="text-sm font-semibold text-gray-500 dark:text-slate-400 w-16 shrink-0">洞察人设</div>
                <select 
                  className="flex-1 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg px-4 py-2.5 text-sm font-medium text-gray-800 dark:text-slate-200 focus:outline-none focus:border-emerald-400"
                  value={benchPersona}
                  onChange={e => setBenchPersona(e.target.value)}
                >
                  <option>所有人群 (全局视图)</option>
                  {dashboardData?.availablePersonas?.map((p, i) => (
                     <option key={i} value={p}>{p}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {benchMain && benchComp && benchMain !== benchComp ? (
            <div className="space-y-6">
              {/* Core Stats Duel */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
                  <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-6 flex items-center">
                    <Activity className="w-5 h-5 mr-2 text-[#2996cf]" /> 核心数据对决 (1v1)
                  </h3>
                  
                  <div className="space-y-6">
                    {/* SOV Duel */}
                    {(() => {
                      const mainSovRaw = competitorTable.find(c => c.brand === benchMain)?.sov || '0%';
                      const compSovRaw = competitorTable.find(c => c.brand === benchComp)?.sov || '0%';
                      const mainSov = parseFloat(mainSovRaw) || 0;
                      const compSov = parseFloat(compSovRaw) || 0;
                      const bothZero = mainSov === 0 && compSov === 0;
                      let mainPct = 0, compPct = 0;
                      if (!bothZero) {
                        const totalSov = mainSov + compSov;
                        mainPct = Math.round((mainSov / totalSov) * 100);
                        compPct = 100 - mainPct;
                      }
                      return (
                        <div>
                          <div className="flex justify-between text-sm mb-2">
                            <span className="font-semibold text-[#2996cf]">{benchMain}</span>
                            <span className="text-gray-500 text-xs">相对 SOV 提及率</span>
                            <span className="font-semibold text-rose-500">{benchComp}</span>
                          </div>
                          <div className="flex h-3 rounded-full overflow-hidden bg-gray-100 dark:bg-slate-700">
                            {bothZero ? (
                              <div className="bg-purple-300 dark:bg-slate-600 transition-all duration-500 w-full flex items-center justify-center"></div>
                            ) : (
                              <>
                                <div className="bg-[#2996cf] transition-all duration-500" style={{ width: `${mainPct}%` }}></div>
                                <div className="bg-rose-400 transition-all duration-500" style={{ width: `${compPct}%` }}></div>
                              </>
                            )}
                          </div>
                          <div className="flex justify-between text-xs mt-1 text-slate-500">
                            <span>{mainSovRaw}</span>
                            <span>{compSovRaw}</span>
                          </div>
                        </div>
                      );
                    })()}

                    {/* Sentiment Duel */}
                    {(() => {
                      const mainRecRaw = competitorTable.find(c => c.brand === benchMain)?.recommendRate || '0%';
                      const compRecRaw = competitorTable.find(c => c.brand === benchComp)?.recommendRate || '0%';
                      const mainRec = parseFloat(mainRecRaw) || 0;
                      const compRec = parseFloat(compRecRaw) || 0;
                      const bothZero = mainRec === 0 && compRec === 0;
                      let mainPct = 0, compPct = 0;
                      if (!bothZero) {
                        const totalRec = mainRec + compRec;
                        mainPct = Math.round((mainRec / totalRec) * 100);
                        compPct = 100 - mainPct;
                      }
                      return (
                        <div>
                          <div className="flex justify-between text-sm mb-2">
                            <span className="font-semibold text-[#2996cf]">{benchMain}</span>
                            <span className="text-gray-500 text-xs">综合好感度对抗</span>
                            <span className="font-semibold text-rose-500">{benchComp}</span>
                          </div>
                          <div className="flex h-3 rounded-full overflow-hidden bg-gray-100 dark:bg-slate-700">
                            {bothZero ? (
                              <div className="bg-purple-300 dark:bg-slate-600 transition-all duration-500 w-full flex items-center justify-center"></div>
                            ) : (
                              <>
                                <div className="bg-[#2996cf] transition-all duration-500" style={{ width: `${mainPct}%` }}></div>
                                <div className="bg-rose-400 transition-all duration-500" style={{ width: `${compPct}%` }}></div>
                              </>
                            )}
                          </div>
                          <div className="flex justify-between text-xs mt-1 text-slate-500">
                            <span>{mainRecRaw}</span>
                            <span>{compRecRaw}</span>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Radar Duel */}
                <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
                  <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-2 flex items-center">
                    <Target className="w-5 h-5 mr-2 text-[#2996cf]" /> 能力维度重叠分析
                  </h3>
                  <div className="h-48 flex items-center justify-center text-slate-400 text-sm">
                     <Radar data={{
                        labels: heatmapDimensions.length > 0 ? heatmapDimensions : ['性能', '价格', '外观', '智能', '续航'],
                        datasets: [
                          {
                            label: benchMain,
                            data: heatmapScores[benchMain] || [0,0,0,0,0],
                            backgroundColor: 'rgba(41, 150, 207, 0.2)',
                            borderColor: '#2996cf',
                            borderWidth: 2,
                          },
                          {
                            label: benchComp,
                            data: heatmapScores[benchComp] || [0,0,0,0,0],
                            backgroundColor: 'rgba(244, 63, 94, 0.2)',
                            borderColor: '#f43f5e',
                            borderWidth: 2,
                          }
                        ]
                     }} options={radarOptions} />
                  </div>
                </div>
              </div>

              {/* Pros vs Cons Duel */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-sky-50/50 dark:bg-slate-800/50 border border-sky-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
                  <h4 className="font-bold text-lg text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-[#2996cf]"></div>
                    {benchMain} 核心卖点与痛点
                  </h4>
                  <div className="space-y-4">
                    <div>
                      <div className="text-sm text-emerald-600 dark:text-emerald-400 font-medium mb-2 flex items-center"><Check className="w-4 h-4 mr-1"/> 引擎共识优势 (Pros)</div>
                      <div className="flex flex-wrap gap-2">
                        {competitorTable.find(c => c.brand === benchMain)?.pros?.map((p, i) => (
                           <span key={i} className="px-3 py-1.5 bg-white dark:bg-slate-800 border border-emerald-200 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400 rounded-lg text-sm shadow-sm">{p}</span>
                        )) || <span className="text-slate-400 text-sm">暂无数据</span>}
                      </div>
                    </div>
                    <div>
                      <div className="text-sm text-rose-600 dark:text-rose-400 font-medium mb-2 flex items-center"><X className="w-4 h-4 mr-1"/> 引擎共识痛点 (Cons)</div>
                      <div className="flex flex-wrap gap-2">
                        {competitorTable.find(c => c.brand === benchMain)?.cons?.map((c, i) => (
                           <span key={i} className="px-3 py-1.5 bg-white dark:bg-slate-800 border border-rose-200 dark:border-rose-800 text-rose-700 dark:text-rose-400 rounded-lg text-sm shadow-sm cursor-pointer hover:bg-rose-50 dark:hover:bg-rose-900/40" onClick={() => openEvidenceDrawer(`🔍 【${benchMain}】核心劣势 (${c}) 原始对话`, { brand: benchMain, cons: c })}>{c}</span>
                        )) || <span className="text-slate-400 text-sm">暂无数据</span>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-rose-50/30 dark:bg-slate-800/50 border border-rose-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
                  <h4 className="font-bold text-lg text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-rose-400"></div>
                    {benchComp} 核心卖点与痛点
                  </h4>
                  <div className="space-y-4">
                    <div>
                      <div className="text-sm text-emerald-600 dark:text-emerald-400 font-medium mb-2 flex items-center"><Check className="w-4 h-4 mr-1"/> 引擎共识优势 (Pros)</div>
                      <div className="flex flex-wrap gap-2">
                        {competitorTable.find(c => c.brand === benchComp)?.pros?.map((p, i) => (
                           <span key={i} className="px-3 py-1.5 bg-white dark:bg-slate-800 border border-emerald-200 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400 rounded-lg text-sm shadow-sm">{p}</span>
                        )) || <span className="text-slate-400 text-sm">暂无数据</span>}
                      </div>
                    </div>
                    <div>
                      <div className="text-sm text-rose-600 dark:text-rose-400 font-medium mb-2 flex items-center"><X className="w-4 h-4 mr-1"/> 引擎共识痛点 (Cons)</div>
                      <div className="flex flex-wrap gap-2">
                        {competitorTable.find(c => c.brand === benchComp)?.cons?.map((c, i) => (
                           <span key={i} className="px-3 py-1.5 bg-white dark:bg-slate-800 border border-rose-200 dark:border-rose-800 text-rose-700 dark:text-rose-400 rounded-lg text-sm shadow-sm cursor-pointer hover:bg-rose-50 dark:hover:bg-rose-900/40" onClick={() => openEvidenceDrawer(`🔍 【${benchComp}】核心劣势 (${c}) 原始对话`, { brand: benchComp, cons: c })}>{c}</span>
                        )) || <span className="text-slate-400 text-sm">暂无数据</span>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Dynamic Win-Rate Matrix */}
              <div className="bg-white dark:bg-slate-800/50 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
                <h3 className="font-semibold text-gray-900 dark:text-slate-200 mb-4 flex items-center">
                  <Activity className="w-5 h-5 mr-2 text-[#2996cf]" /> {benchPersona} 下的场景胜率地图
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full text-left border-collapse">
                    <thead>
                      <tr className="border-b border-gray-200 dark:border-slate-700 text-sm text-slate-500">
                        <th className="pb-3 font-medium">应用场景 / 评估维度</th>
                        <th className="pb-3 font-medium text-center">{benchMain} 胜率</th>
                        <th className="pb-3 font-medium text-center">{benchComp} 胜率</th>
                        <th className="pb-3 font-medium">引擎倾向性结论</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm">
                      {heatmapDimensions.length > 0 ? heatmapDimensions.map((dim, idx) => {
                        const mainScore = heatmapScores[benchMain]?.[idx] || 0;
                        const compScore = heatmapScores[benchComp]?.[idx] || 0;
                        let conclusion = '';
                        if (mainScore > compScore + 10) conclusion = `在"${dim}"相关提问中，AI明显偏向推荐 ${benchMain}。`;
                        else if (compScore > mainScore + 10) conclusion = `在"${dim}"相关提问中，AI明显偏向推荐 ${benchComp}。`;
                        else conclusion = `在"${dim}"相关提问中，AI对两者的评价势均力敌。`;
                        
                        return (
                          <tr key={idx} className="border-b border-gray-100 dark:border-slate-700/50 last:border-0 hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-colors">
                            <td className="py-4 font-medium text-gray-800 dark:text-slate-300 pl-2">{dim}</td>
                            <td className="py-4 text-center text-[#2996cf] font-bold">{mainScore}%</td>
                            <td className="py-4 text-center text-rose-500 font-bold">{compScore}%</td>
                            <td className="py-4 text-gray-600 dark:text-slate-400 text-xs">
                               {conclusion}
                            </td>
                          </tr>
                        );
                      }) : (
                        <tr><td colSpan="4" className="py-8 text-center text-slate-500">暂无维度数据</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
             <div className="flex flex-col items-center justify-center py-16 text-center bg-white dark:bg-slate-800/50 rounded-xl border border-gray-100 dark:border-slate-700/50">
                <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4 text-slate-400">
                  <Target className="w-8 h-8" />
                </div>
                <h3 className="text-lg font-medium text-gray-900 dark:text-slate-200">请选择不同的主推品牌与竞品进行对标</h3>
             </div>
          )}
        </div>
      ) : activeView === 'persona' ? (
        <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 pb-16">
          <PersonaInsightsTab 
            brandProjectId={globalBrand === 'undefined' ? 'all' : (globalBrand || 'all')} 
            taskId={globalProject === 'undefined' ? 'all' : (globalProject || 'all')}
            filters={filters}
            fetchMode={globalFetchMode}
            onDrawerOpen={(details) => {
              // we can wire up the evidence drawer later if needed, passing a prop for now
            }}
          />
        </div>
      ) : activeView === 'strategic' && globalProject === '210' ? (
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-500 pb-16">
          <div className="bg-white/60 dark:bg-slate-800/80 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-2xl p-8 shadow-sm text-slate-800 dark:text-slate-200">
            
            {/* Report Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 border-b border-gray-200 dark:border-slate-700 pb-6">
              <div>
                <div className="inline-flex items-center space-x-2 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                  <span className="w-2 h-2 rounded-full bg-indigo-500 animate-pulse"></span>
                  <span>Digital Ecosystem Audit V1.0</span>
                </div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-slate-100">
                  AI 生态品牌智能审计报告
                </h1>
                <p className="text-gray-500 dark:text-slate-400 mt-2 text-sm">
                  目标品牌：Hermès | 分析样本：608条主流AI原生输出 | 核心议题：AI基础设施化对品牌资产的重塑
                </p>
              </div>
              <div className="mt-4 md:mt-0 flex flex-col items-end">
                <span className="text-sm font-semibold text-gray-900 dark:text-slate-300">独立战略分析师：Sapient Rank</span>
                <span className="text-xs text-gray-400 dark:text-slate-500">2026-07 Confidential</span>
              </div>
            </div>
            
            <div className="space-y-12">
              
              {/* 模块一：AI 发展阶段评估 */}
              <section>
                <h2 className="text-xl font-bold text-gray-900 dark:text-slate-100 mb-6 flex items-center gap-2">
                  <span className="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-400 flex items-center justify-center">1</span>
                  AI 发展阶段评估基准线
                </h2>
                <div className="relative p-6 bg-slate-50 dark:bg-slate-900/50 rounded-xl border border-slate-100 dark:border-slate-800 overflow-hidden">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gray-200 via-blue-400 to-indigo-600"></div>
                  <div className="grid grid-cols-5 gap-4 mt-4 relative z-10">
                    <div className="text-center opacity-40">
                      <div className="text-xs font-bold uppercase tracking-wider mb-2 text-slate-500 dark:text-slate-400">Stage 1</div>
                      <div className="font-semibold text-gray-700 dark:text-slate-300">Tool (工具)</div>
                      <div className="text-[10px] text-gray-500 dark:text-slate-400 mt-1">主动问答</div>
                    </div>
                    <div className="text-center relative">
                      <div className="text-xs font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-2">Stage 2</div>
                      <div className="font-semibold text-gray-900 dark:text-white">Assistant (助手)</div>
                      <div className="text-[10px] text-gray-500 dark:text-slate-400 mt-1">影响决策边界</div>
                      {/* Marker */}
                      <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center">
                        <div className="bg-white dark:bg-slate-700 shadow-sm border border-gray-200 dark:border-slate-600 text-xs px-2 py-1 rounded-md whitespace-nowrap text-slate-800 dark:text-slate-200">主流AI当前所处位置</div>
                        <div className="w-0.5 h-6 bg-blue-400"></div>
                        <div className="w-3 h-3 rounded-full bg-blue-500 border-2 border-white dark:border-slate-800"></div>
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="text-xs font-bold uppercase tracking-wider mb-2 text-slate-500 dark:text-slate-400">Stage 3</div>
                      <div className="font-semibold text-gray-700 dark:text-slate-300">Agent (代理)</div>
                      <div className="text-[10px] text-gray-500 dark:text-slate-400 mt-1">主动执行购买</div>
                    </div>
                    <div className="text-center opacity-50">
                      <div className="text-xs font-bold uppercase tracking-wider mb-2 text-slate-500 dark:text-slate-400">Stage 4</div>
                      <div className="font-semibold text-gray-700 dark:text-slate-300">Ecosystem (生态)</div>
                      <div className="text-[10px] text-gray-500 dark:text-slate-400 mt-1">唯一超级入口</div>
                    </div>
                    <div className="text-center opacity-30">
                      <div className="text-xs font-bold uppercase tracking-wider mb-2 text-slate-500 dark:text-slate-400">Stage 5</div>
                      <div className="font-semibold text-gray-700 dark:text-slate-300">Infrastructure (基建)</div>
                      <div className="text-[10px] text-gray-500 dark:text-slate-400 mt-1">底层无感分发</div>
                    </div>
                  </div>
                  <div className="mt-8 pt-6 border-t border-gray-200 dark:border-slate-700">
                    <p className="text-sm text-gray-600 dark:text-slate-300 leading-relaxed">
                      <strong>核心发现：</strong>当今中国主流 AI 生态正处于从 <strong>Stage 2 (决策助手)</strong> 向 <strong>Stage 3 (行动代理)</strong> 的跨越期。它们已经深刻改变了消费者的品牌认知（如解释 Hermès 的配货潜规则、评估手袋保值率），但尚未完全接管支付与预订。在此阶段，品牌在 AI 语料库中的“世界观定义权”至关重要，因为这决定了未来 AI 成为代理 (Agent) 时，是否会将爱马仕推入消费者的自动购买队列中。
                    </p>
                  </div>
                </div>
              </section>

              {/* 模块二：生态叙事拆解 */}
              <section>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                  <h2 className="text-xl font-bold text-gray-900 dark:text-slate-100 flex items-center gap-2">
                    <span className="w-8 h-8 rounded-lg bg-orange-100 text-orange-600 dark:bg-orange-900/50 dark:text-orange-400 flex items-center justify-center">2</span>
                    六大 AI 生态叙事拆解与信源反推
                  </h2>
                  <button 
                    onClick={exportSourcesData}
                    className="flex items-center gap-2 px-4 py-2 bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 rounded-lg text-sm font-medium hover:bg-orange-100 dark:hover:bg-orange-900/40 transition-colors"
                  >
                    <Download className="w-4 h-4" />
                    下载信源 RawData
                  </button>
                </div>
                
                <div className="flex flex-col md:flex-row gap-6">
                  {/* Vertical Tabs */}
                  <div className="w-full md:w-48 flex-shrink-0 flex flex-row md:flex-col gap-2 overflow-x-auto md:overflow-visible" style={{scrollbarWidth: 'none'}}>
                    {['DeepSeek', 'Kimi', '豆包 (Doubao)', '通义千问 (Qwen)', '文心一言 (Ernie)', '腾讯元宝'].map(engine => (
                      <button
                        key={engine}
                        onClick={() => setActiveEngineTab(engine)}
                        className={`px-4 py-3 text-left rounded-lg text-sm font-semibold transition-all whitespace-nowrap ${activeEngineTab === engine ? 'bg-[#2996cf] text-white shadow-md' : 'bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-slate-400 hover:bg-gray-200 dark:hover:bg-slate-700'}`}
                      >
                        {engine}
                      </button>
                    ))}
                  </div>

                  {/* Tab Content */}
                  <div className="flex-1 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-xl p-6 shadow-sm min-h-[300px]">
                    <div className="animate-in fade-in duration-300">
                      <div className="flex items-center gap-3 mb-4">
                        <h3 className="text-lg font-bold text-gray-900 dark:text-white">{activeEngineTab}</h3>
                      </div>
                      
                      {narrativeData[activeEngineTab] ? (
                        <>
                          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            <div>
                              <h4 className="text-sm font-semibold text-gray-500 dark:text-slate-400 mb-2">共同理解与叙事差异</h4>
                              <p className="text-sm text-gray-700 dark:text-slate-300 leading-relaxed bg-slate-50 dark:bg-slate-800 p-4 rounded-lg">
                                {narrativeData[activeEngineTab]["共同理解与叙事差异"]}
                              </p>
                            </div>
                            <div>
                              <h4 className="text-sm font-semibold text-gray-500 dark:text-slate-400 mb-2">生态偏向 & 阶段证据</h4>
                              <p className="text-sm text-gray-700 dark:text-slate-300 leading-relaxed bg-slate-50 dark:bg-slate-800 p-4 rounded-lg mb-2">
                                <strong>生态偏向:</strong> {narrativeData[activeEngineTab]["生态偏向"]}
                              </p>
                              <p className="text-sm text-gray-700 dark:text-slate-300 leading-relaxed bg-slate-50 dark:bg-slate-800 p-4 rounded-lg">
                                <strong>阶段证据:</strong> {narrativeData[activeEngineTab]["阶段成熟度证据"]}
                              </p>
                            </div>
                          </div>
                          <div className="mt-6 border-t border-gray-100 dark:border-slate-700 pt-4">
                            <h4 className="text-sm font-semibold text-gray-900 dark:text-slate-200 mb-2">⚠️ 优势与盲点</h4>
                            <p className="text-sm text-gray-600 dark:text-slate-400">{narrativeData[activeEngineTab]["优势与盲点"]}</p>
                          </div>
                        </>
                      ) : (
                        <div className="text-slate-500 text-sm py-10 text-center">暂无该引擎的独立分析数据。</div>
                      )}
                    </div>
                  </div>
                </div>
              </section>

              {/* 模块三：十维度生态叙事切片面板 */}
              <section>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                  <h2 className="text-xl font-bold text-gray-900 dark:text-slate-100 flex items-center gap-2">
                    <span className="w-8 h-8 rounded-lg bg-emerald-100 text-emerald-600 dark:bg-emerald-900/50 dark:text-emerald-400 flex items-center justify-center">3</span>
                    十维度生态叙事切片面板 (10-Dimension Narrative Explorer)
                  </h2>
                  <button 
                    onClick={exportDimensionData}
                    className="flex items-center gap-2 px-4 py-2 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 rounded-lg text-sm font-medium hover:bg-emerald-100 dark:hover:bg-emerald-900/40 transition-colors"
                  >
                    <Download className="w-4 h-4" />
                    下载源回答 RawData
                  </button>
                </div>
                <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-xl p-0 shadow-sm flex flex-col lg:flex-row overflow-hidden">
                  
                  {/* Left Navigation */}
                  <div className="w-full lg:w-1/3 bg-gray-50 dark:bg-slate-800/50 border-r border-gray-200 dark:border-slate-700 p-4 max-h-[500px] overflow-y-auto" style={{scrollbarWidth: 'thin'}}>
                    <div className="text-xs font-bold text-gray-400 dark:text-slate-500 uppercase tracking-wider mb-4 px-2">审计维度基准 (Audit Dimensions)</div>
                    <div className="space-y-1">
                      {['品牌知识', '品牌哲学', '消费者洞察', '中国文化理解', '推荐能力', '非品类扩展', '竞争定位', '生态能力', 'AI阶段成熟度', '未来战略洞察'].map(dim => (
                        <button
                          key={dim}
                          onClick={() => setActiveDimTab(dim)}
                          className={`w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${activeDimTab === dim ? 'bg-white dark:bg-slate-700 text-[#2996cf] shadow-sm border border-gray-200 dark:border-slate-600' : 'text-gray-600 dark:text-slate-400 hover:bg-gray-200/50 dark:hover:bg-slate-800'}`}
                        >
                          {dim}
                        </button>
                      ))}
                    </div>
                  </div>
                  
                  {/* Right Content */}
                  <div className="w-full lg:w-2/3 p-6 lg:p-8 min-h-[400px] flex flex-col bg-white dark:bg-slate-900">
                    <div className="mb-6 pb-4 border-b border-gray-100 dark:border-slate-800">
                      <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center">
                        <span className="text-[#2996cf] mr-2">#</span> {activeDimTab}
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-slate-400 mt-2">基于 608 条 AI 原生回答真实提取，客观呈现各生态平台的叙事底色差异。</p>
                    </div>
                    
                    <div className="space-y-5 flex-1 animate-in fade-in duration-300">
                      {Object.entries(narrativeData).map(([engine, dims]) => {
                        const text = dims[activeDimTab];
                        if (!text) return null;
                        
                        let containerClass = "p-4 rounded-lg border ";
                        let titleClass = "font-semibold block mb-1 ";
                        
                        if (engine === 'DeepSeek') {
                           containerClass += "bg-blue-50 dark:bg-blue-900/10 border-blue-100 dark:border-blue-900/30";
                           titleClass += "text-blue-700 dark:text-blue-400";
                        } else if (engine.includes('豆包')) {
                           containerClass += "bg-rose-50 dark:bg-rose-900/10 border-rose-100 dark:border-rose-900/30";
                           titleClass += "text-rose-700 dark:text-rose-400";
                        } else if (engine === '通义千问') {
                           containerClass += "bg-orange-50 dark:bg-orange-900/10 border-orange-100 dark:border-orange-900/30";
                           titleClass += "text-orange-700 dark:text-orange-400";
                        } else if (engine === 'Kimi') {
                           containerClass += "bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700";
                           titleClass += "text-slate-700 dark:text-slate-300";
                        } else if (engine === '文心一言') {
                           containerClass += "bg-cyan-50 dark:bg-cyan-900/10 border-cyan-100 dark:border-cyan-900/30";
                           titleClass += "text-cyan-700 dark:text-cyan-400";
                        } else if (engine === '腾讯元宝') {
                           containerClass += "bg-green-50 dark:bg-green-900/10 border-green-100 dark:border-green-900/30";
                           titleClass += "text-green-700 dark:text-green-400";
                        } else {
                           containerClass += "bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700";
                           titleClass += "text-gray-700 dark:text-gray-300";
                        }
                        
                        return (
                          <div key={engine} className={containerClass}>
                            <span className={titleClass}>{engine}</span>
                            <span className="text-sm text-gray-700 dark:text-slate-300">{text}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </section>
              
            </div>
          </div>

        </div>
      ) : null}
      </div>
      </>
      )}
      </div>

      {/* Evidence Drawer Overlay & Content */}
      <div className={`fixed inset-0 z-[60] transition-opacity duration-300 ${isDrawerOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={closeDrawer}></div>
        
        {/* Drawer Panel */}
        <div className={`absolute top-0 right-0 h-full w-full sm:w-[600px] bg-white dark:bg-slate-900 border-l border-gray-200 dark:border-slate-800 shadow-2xl transition-transform duration-300 transform flex flex-col ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-800 flex items-center justify-between bg-gray-50/50 dark:bg-slate-900/50">
            <h3 className="text-lg font-semibold text-slate-800 dark:text-white flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-[#2996cf]" />
              {drawerTitle}
            </h3>
            <button onClick={closeDrawer} className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar bg-slate-50/30 dark:bg-slate-900">
            {drawerLoading ? (
               <div className="flex justify-center items-center h-full text-slate-400">正在检索溯源记录...</div>
            ) : (
               drawerData.map((record, index) => (
                 <div key={index} className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm overflow-hidden mb-6">
                    <div className="px-4 py-3 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-800/50 flex justify-between items-center">
                       <div className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
                          {engineLogos[record.platform] && <img src={engineLogos[record.platform]} className="w-5 h-5" />}
                          {record.platform}
                       </div>
                       <div className="text-xs text-slate-400">{record.time}</div>
                    </div>
                    <div className="p-4 space-y-4">
                        {/* User Question */}
                        <div className="flex justify-end pr-2">
                          <div className="bg-[#2996cf] text-white rounded-2xl rounded-tr-sm px-4 py-3 max-w-[90%] shadow-sm text-sm">
                            {record.question}
                          </div>
                        
                            
                        </div>
                        {/* AI Response */}
                        <div className="flex justify-start pl-2">
                          <div className="bg-gray-50 dark:bg-slate-900 text-slate-700 dark:text-slate-300 rounded-2xl rounded-tl-sm px-4 py-4 max-w-[95%] border border-gray-200 dark:border-slate-700 shadow-sm text-sm prose prose-sm dark:prose-invert max-w-none max-h-[400px] overflow-y-auto custom-scrollbar [&_li_p]:my-0">
                            <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
                              {(() => {
let cleanAns = record.rawResponse || '';
                                cleanAns = cleanAns.replace(/\>\s*.*商品卡片.*(?:(?:\r?\n)\>.*)*/g, '');
                                cleanAns = cleanAns.replace(/```json[\s\S]*?```/g, '');
                                cleanAns = cleanAns.replace(/\[\s*\{[\s\S]*\}\s*\]\s*$/, '');
                        cleanAns = cleanAns.replace(/::dqa:(quote|image|link|list|knowledge):[\s\S]*?::/g, '');
                                cleanAns = cleanAns.replace(/::dqa:underline:(.*?)::/g, (match, p1) => {
                                    try {
                                        const obj = JSON.parse(p1);
                                        return obj.text ? obj.text : p1;
                                    } catch(e) { return match; }
                                });
                                cleanAns = cleanAns.replace(/(\d+\.[^\n]+)\n+(1\.\s)/g, '$1\n\n---\n\n$2');
                                cleanAns = cleanAns.replace(/\n{3,}/g, '\n\n');
                                return cleanAns.trim();
                              })()}
                            </ReactMarkdown>

                            
                            {/* 小红书 AIO 特色 UI：品牌萃取卡片 */}
                            {record.xhsBrandDetails && record.xhsBrandDetails.length > 0 && (
                              <div className="mt-4 mb-4">
                                <div className="flex items-center gap-1.5 text-xs text-[#ff2442] font-bold mb-3">
                                  <svg className="w-4 h-4" viewBox="0 0 1024 1024" fill="currentColor">
                                    <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#ff2442"/>
                                    <path d="M512 841.142857C329.142857 841.142857 182.857143 694.857143 182.857143 512S329.142857 182.857143 512 182.857143s329.142857 146.285714 329.142857 329.142857-146.285714 329.142857-329.142857 329.142857z" fill="#ff2442"/>
                                    <path d="M725.333333 460.8v102.4H306.041143v-102.4h419.29219z" fill="#ffffff"/>
                                    <path d="M563.2 292.571429v438.857142h-102.4V292.571429h102.4z" fill="#ffffff"/>
                                  </svg>
                                  <span>小红书 AI 专属总结 (AIO)</span>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  {record.xhsBrandDetails.filter(b => b.brandName || b.mentionContent).map((bDetail, idx) => (
                                    <div key={idx} className="bg-red-50/40 dark:bg-[#ff2442]/10 border border-red-100 dark:border-red-900/30 rounded-xl p-3 relative overflow-hidden">
                                      <div className="absolute top-0 right-0 bg-[#ff2442] text-white text-[10px] font-black px-2 py-0.5 rounded-bl-lg">
                                        TOP {bDetail.brandRank || '-'}
                                      </div>
                                      <div className="flex items-center gap-2 mb-2">
                                        <div className="font-bold text-slate-800 dark:text-slate-200 text-sm">
                                          {bDetail.brandName || '未命名品牌'}
                                        </div>
                                        
                                        {bDetail.recommendRatio && (
                                          <div className="text-[10px] bg-red-100 dark:bg-red-900/50 text-[#ff2442] dark:text-red-300 px-1.5 py-0.5 rounded-sm">
                                            推荐度 {bDetail.recommendRatio}%
                                          </div>
                                        )}
                                      </div>
                                      {bDetail.mentionContent && (
                                        <div className="text-xs text-slate-600 dark:text-slate-400 line-clamp-2 mb-1" title={bDetail.mentionContent}>
                                          <span className="font-semibold text-slate-700 dark:text-slate-300">核心卖点：</span>
                                          {bDetail.mentionContent}
                                        </div>
                                      )}
                                      {bDetail.brandViewpoint && (
                                        <div className="text-xs text-slate-600 dark:text-slate-400 line-clamp-2" title={bDetail.brandViewpoint}>
                                          <span className="font-semibold text-slate-700 dark:text-slate-300">用户观点：</span>
                                          {bDetail.brandViewpoint}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}


                            {/* Product Cards UI */}
                            {record.productCards && record.productCards.length > 0 && (
                                <div className="mt-4 space-y-3">
                                    <div className="flex items-center gap-1.5 text-xs text-amber-600 dark:text-amber-400 font-bold mb-2">
                                        <ShoppingBag className="w-4 h-4" />
                                        <span>引擎在此回答中动态插入了以下商品导购卡片：</span>
                                    </div>
                                    <div className="flex flex-wrap gap-4">
                                        {(() => {
                                            let parsedCards = record.productCards;
                                            if (typeof parsedCards === 'string') {
                                                try { parsedCards = JSON.parse(parsedCards); } catch(e) {}
                                            }
                                            return Array.isArray(parsedCards) ? parsedCards.map((card, idx) => (
                                                <div key={idx} className="flex bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg shadow-sm hover:shadow-md transition-shadow p-2 w-[280px] gap-3 relative group">
                                                    <div className="w-16 h-16 flex-shrink-0 rounded-md overflow-hidden bg-white dark:bg-slate-800 flex items-center justify-center border border-gray-100 dark:border-slate-600">
                                                        {card.imageUrl ? <img src={card.imageUrl} alt={card.productName} className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform cursor-pointer" onClick={() => setZoomedImage(card.imageUrl)} /> : <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">无图</div>}
                                                    </div>
                                                    <div className="flex flex-col justify-between overflow-hidden">
                                                        <div>
                                                            <div className="text-sm font-bold text-gray-800 dark:text-slate-200 truncate" title={card.productName}>{card.productName}</div>
                                                            <div className="text-[10px] text-gray-500 dark:text-slate-400 line-clamp-2 leading-tight mt-0.5" title={card.details}>{card.details}</div>
                                                        </div>
                                                        <div className="mt-1 flex items-center justify-between">
                                                            <span className="inline-block bg-orange-50 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-[9px] px-1.5 py-0.5 rounded font-medium truncate max-w-[120px]">{card.merchant}</span>
                                                            
                                                            {/* Crop Button */}
            {record && record.sources && record.sources.length > 0 && (record.engineId === 'qwmb' || record.engineId === 'tyqw' || (record.engineName && record.engineName.toLowerCase().includes('qianwen'))) && (
                                                              <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    const srcObj = record.sources.find(s => s.url || s.link || s.URL || s.Url) || record.sources[0]; setCropTarget({ recordId: record.id, cardIndex: idx, sourceUrl: srcObj.url || srcObj.link || srcObj.URL || srcObj.Url });
                                                                }}
                                                                className="ml-2 bg-blue-50 hover:bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:hover:bg-blue-800/50 dark:text-blue-400 p-1 rounded transition-colors"
                                                                title="手工校准截图"
                                                              >
                                                                <Crop className="w-3 h-3" />
                                                              </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )) : null;
                                        })()}
                                    </div>
                                </div>
                            )}

                            
                            {/* 小红书信源瀑布流展示 */}
                            {record.xhsRawNotes && record.xhsRawNotes.length > 0 && (
                              <div className="mt-4 pt-3 border-t border-gray-200 dark:border-slate-700">
                                <div className="flex items-center justify-between mb-3">
                                  <p className="text-xs font-bold text-[#ff2442]">AIO 引用溯源 (小红书笔记):</p>
                                </div>
                                <div className="columns-1 sm:columns-2 gap-4 space-y-4">
                                  {record.xhsRawNotes.map((note, idx) => (
                                    <div key={idx} className="break-inside-avoid bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group cursor-pointer relative" onClick={() => window.open(note.noteUrl || '#', '_blank')}>
                                      {/* 笔记指标悬浮层 */}
                                      <div className="absolute top-2 right-2 flex flex-col gap-1 z-10 pointer-events-none opacity-90">
                                        <div className="bg-black/50 backdrop-blur text-white text-[9px] px-1.5 py-0.5 rounded-md flex items-center gap-1">
                                          <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path></svg>
                                          {note.likeCount || 0}
                                        </div>
                                      </div>
      
                                      <div className="p-3">
                                        <div className="text-xs font-bold text-slate-800 dark:text-slate-200 line-clamp-2 mb-1.5 leading-snug group-hover:text-[#ff2442] transition-colors">
                                          {note.title || '无标题笔记'}
                                        </div>
                                        <div className="text-[10px] text-slate-500 dark:text-slate-400 line-clamp-3 mb-2">
                                          {note.content}
                                        </div>
                                        <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-100 dark:border-slate-700/50">
                                          <div className="flex items-center gap-1.5">
                                            <div className="w-4 h-4 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center overflow-hidden">
                                              <svg className="w-2.5 h-2.5 text-slate-400" fill="currentColor" viewBox="0 0 24 24"><path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                                            </div>
                                            <span className="text-[10px] text-slate-500 dark:text-slate-400 truncate max-w-[80px]">{note.nickname || '小红书用户'}</span>
                                          </div>
                                          {note.timeText && <span className="text-[9px] text-slate-400">{note.timeText}</span>}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                            
                            {record.sources && record.sources.length > 0 && (
                                <div className="mt-4 pt-3 border-t border-gray-200 dark:border-slate-700">
                                    <p className="text-xs font-bold text-gray-500 dark:text-slate-400 mb-2">
                                      {(record.engineId === 'xhs' || record.engineId === '小红书' || record.engineId === '小红书AI' || record.engineId === '小红书ai') ? '小红书自然排名笔记 (Organic Results):' : '引用的信源:'}
                                    </p>
                                    <div className="flex flex-wrap gap-2">
                                        {record.sources
                                        .filter(src => src.name !== '小红书AI回答' && src.title !== '小红书AI回答' && src.url !== '小红书AI回答')
                                        .map((src, i) => {
                                            const displayName = src.title || src.name || '未知来源';
                                            if (src.url && src.url.trim() !== '' && src.url !== 'brand_detail') {
                                                return (
                                                    <a key={i} href={src.url} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 px-2.5 py-1 rounded border border-blue-100 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors text-xs no-underline max-w-full" title={displayName}>
                                                        <svg className="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                                        <span className="truncate max-w-[200px]">{displayName}</span>
                                                    </a>
                                                );
                                            } else {
                                                return (
                                                    <span key={i} className="flex items-center space-x-1 bg-slate-50 dark:bg-slate-800/50 text-slate-600 dark:text-slate-400 px-2.5 py-1 rounded border border-slate-200 dark:border-slate-700 text-xs max-w-full cursor-default" title={displayName}>
                                                        <svg className="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path></svg>
                                                        <span className="truncate max-w-[200px]">{displayName}</span>
                                                    </span>
                                                );
                                            }
                                        })}
                                    </div>
                                </div>
                              )}



                          </div>
                        </div>
                        
                        {/* New floating-style Zhimo Intervention Action Bar */}
                        {(record.sentiment === 'negative' || record.sentiment === 'controversial' || drawerTitle.includes('负向') || drawerTitle.includes('争议') || drawerTitle.includes('劣势')) && (
                          <div className="flex justify-start pl-2 mt-2 group relative z-10">
                             <button 
                                onClick={() => {
                                  setZhimoCitation(record);
                                  setZhimoSelectedSources(record.sources ? record.sources.map((s, idx) => s.url || s.name || String(idx)) : []);
                                  setIsZhimoDrawerOpen(true);
                                }}
                                className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 dark:bg-indigo-900/60 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-200 dark:hover:bg-indigo-800 transition-colors shadow-sm ring-2 ring-white dark:ring-slate-800 cursor-pointer"
                             >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
                             </button>
                             
                             {/* Tooltip on hover */}
                             <div className="absolute left-10 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity bg-indigo-600 text-white text-xs px-2.5 py-1.5 rounded shadow-lg whitespace-nowrap">
                                🛡️ 调起智墨创作舱进行防守干预
                             </div>
                          </div>
                        )}
                        
                    </div>
                 </div>
               ))
            )}
          </div>
        </div>
      </div>


      {/* Media & Article Type Drawer */}
      <div className={`fixed inset-0 z-[60] transition-opacity duration-300 ${isMediaDrawerOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={closeMediaDrawer}></div>
        <div className={`absolute top-0 right-0 h-full w-full sm:w-[1000px] max-w-[95vw] bg-white dark:bg-slate-900 border-l border-gray-200 dark:border-slate-800 shadow-2xl transition-transform duration-300 transform flex flex-col ${isMediaDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="flex-none flex items-center justify-between p-6 border-b border-gray-200 dark:border-slate-800">
            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-3">
              {mediaDrawerTitle}
              <span className="bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400 text-xs px-2 py-1 rounded-full font-medium">
                {mediaDrawerData.length} 条引证
              </span>
            </h2>
            <div className="flex items-center gap-3">
              <button onClick={handleExportMediaExcel} className="flex items-center gap-2 px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg transition-colors text-sm font-medium shadow-sm">
                <Download className="w-4 h-4" /> 导出 Excel
              </button>
              <button onClick={closeMediaDrawer} className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors">
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50/50 dark:bg-[#0f172a]">
            {mediaDrawerLoading ? (
              <div className="flex flex-col items-center justify-center h-48 space-y-4">
                <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
                <p className="text-sm text-slate-500 dark:text-slate-400 animate-pulse">正在深度追溯媒体来源...</p>
              </div>
            ) : mediaDrawerData.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-48 space-y-3">
                <div className="w-12 h-12 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center">
                  <Search className="w-6 h-6 text-slate-400" />
                </div>
                <p className="text-slate-500 dark:text-slate-400">未找到相关溯源数据</p>
              </div>
            ) : (
              <div className="space-y-4">
                <div className="overflow-x-auto border border-gray-200 dark:border-slate-800 rounded-xl shadow-sm bg-white dark:bg-slate-900">
                  <table className="w-full text-sm text-left">
                    <thead className="bg-gray-50 dark:bg-slate-800/50 text-gray-600 dark:text-slate-300">
                      <tr>
                        <th className="px-4 py-3 font-medium whitespace-nowrap w-24">来源媒体</th>
                        <th className="px-4 py-3 font-medium whitespace-nowrap w-32">内容类型</th>
                        <th className="px-4 py-3 font-medium whitespace-nowrap w-28">引用引擎</th>
                        <th className="px-4 py-3 font-medium whitespace-nowrap w-32">
                          最终 AI 倾向
                          <span className="inline-block ml-1 text-slate-400 cursor-help" title="指 AI 最终合成回答对该品牌的整体评价，并非单篇文章的基调。中立客观的文章也可能被 AI 用作竞争对比时的负面论据。">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="inline-block -mt-0.5"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                          </span>
                        </th>
                        <th className="px-4 py-3 font-medium w-full">标题 / 话题</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-slate-800/60">
                      {mediaDrawerData.map((row, idx) => (
                        <tr key={idx} className="hover:bg-gray-50 dark:hover:bg-slate-800/30 transition-colors">
                          <td className="px-4 py-3 font-medium text-gray-900 dark:text-slate-200 whitespace-nowrap max-w-[120px] truncate" title={row.platform}>
                            {row.platform}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className="px-2 py-1 bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-400 rounded-md text-xs border border-purple-100 dark:border-purple-800/50">
                              {row.articleType}
                            </span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className="flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
                              <Bot className="w-3.5 h-3.5 opacity-70" />
                              {row.engineName}
                            </span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            {row.sentiment === 'positive' && <span className="text-emerald-600 dark:text-emerald-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>正面</span>}
                            {row.sentiment === 'negative' && <span className="text-rose-600 dark:text-rose-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500"></span>负面</span>}
                            {row.sentiment === 'neutral' && <span className="text-slate-500 dark:text-slate-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-slate-400"></span>中立</span>}
                            {row.sentiment === 'controversial' && <span className="text-amber-500 dark:text-amber-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span>争议</span>}
                          </td>
                          <td className="px-4 py-3">
                            <div className="text-slate-700 dark:text-slate-300 line-clamp-2" title={row.title}>
                              {row.url !== '#' ? (
                                <a href={row.url} target="_blank" rel="noreferrer" className="hover:text-blue-600 dark:hover:text-blue-400 hover:underline">
                                  {row.title}
                                </a>
                              ) : (
                                row.title
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Zhimo Integration Drawer */}
      {isZhimoDrawerOpen && (
        <div className="fixed inset-0 z-[60] overflow-hidden" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
          <div className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setIsZhimoDrawerOpen(false)}></div>
          <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
            <div className="w-screen max-w-md transform transition-all duration-300 ease-in-out">
              <div className="h-full flex flex-col bg-white dark:bg-slate-800 shadow-xl overflow-y-scroll">
                
                <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-700 bg-indigo-50 dark:bg-indigo-900/20 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="p-1.5 bg-indigo-600 text-white rounded-md">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
                    </span>
                    <h2 className="text-lg font-medium text-gray-900 dark:text-white" id="slide-over-title">智墨 AI 创作舱</h2>
                  </div>
                  <button type="button" className="text-gray-400 hover:text-gray-500 focus:outline-none" onClick={() => setIsZhimoDrawerOpen(false)}>
                    <span className="sr-only">Close panel</span>
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                  </button>
                </div>

                <div className="p-6 flex-1">
                  {/* Selected Citation Info */}
                  <div className="mb-6">
                    <h3 className="text-sm font-medium text-gray-500 dark:text-slate-400 mb-2">引文来源列表 (请勾选需要重点反驳的负面文章)</h3>
                    {zhimoCitation?.sources && zhimoCitation.sources.length > 0 ? (
                      <div className="space-y-2 max-h-60 overflow-y-auto pr-2 custom-scrollbar">
                        {zhimoCitation.sources.map((source, idx) => {
                          const sourceKey = source.url || source.name || String(idx);
                          const isSelected = zhimoSelectedSources.includes(sourceKey);
                          return (
                            <label key={sourceKey} className={`flex items-start p-3 rounded-lg border cursor-pointer transition-colors ${isSelected ? 'bg-indigo-50 border-indigo-200 dark:bg-indigo-900/20 dark:border-indigo-800' : 'bg-gray-50 border-gray-200 dark:bg-slate-900/50 dark:border-slate-700 hover:bg-gray-100 dark:hover:bg-slate-800'}`}>
                              <div className="flex-shrink-0 mt-0.5">
                                <input 
                                  type="checkbox" 
                                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                  checked={isSelected}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setZhimoSelectedSources([...zhimoSelectedSources, sourceKey]);
                                    } else {
                                      setZhimoSelectedSources(zhimoSelectedSources.filter(k => k !== sourceKey));
                                    }
                                  }}
                                />
                              </div>
                              <div className="ml-3 flex-1 min-w-0">
                                <p className="text-sm font-medium text-gray-900 dark:text-slate-200 truncate" title={source.name}>{source.name}</p>
                                {source.url && <p className="text-xs text-blue-500 dark:text-blue-400 truncate hover:underline" title={source.url} onClick={(e) => e.stopPropagation()}><a href={source.url} target="_blank" rel="noreferrer">{source.url}</a></p>}
                                {source.snippet && <p className="text-xs text-gray-600 dark:text-slate-400 mt-1 line-clamp-2" title={source.snippet}>{source.snippet}</p>}
                              </div>
                            </label>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="p-3 bg-gray-50 dark:bg-slate-900/50 rounded-lg border border-gray-200 dark:border-slate-700">
                        <p className="font-medium text-gray-800 dark:text-slate-200 text-sm mb-1">{zhimoCitation?.title || '未知引文来源'}</p>
                        <p className="text-xs text-gray-500 dark:text-slate-400 line-clamp-3">{zhimoCitation?.snippet || (zhimoCitation?.rawResponse ? zhimoCitation.rawResponse.replace(/[#*`_]/g, '').substring(0, 80) + '...' : '暂无内容')}</p>
                      </div>
                    )}
                  </div>

                  {/* Config Options */}
                  {(zhimoCitation ? (zhimoStatuses[zhimoCitation.id] || 'idle') : 'idle') === 'idle' && (
                    <div className="space-y-5">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">目标分发平台</label>
                        <select 
                          value={zhimoPlatform}
                          onChange={(e) => setZhimoPlatform(e.target.value)}
                          className="w-full rounded-md border-gray-300 dark:border-slate-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white p-2 border"
                        >
                          <option value="GENERAL_NEWS">通用媒体文章 (资讯体 / 应对 DeepSeek、Kimi)</option>
                          <option value="WECHAT">微信公众号 (深度长文 / 应对 腾讯元宝)</option>
                          <option value="XHS">小红书 (图文种草 / 应对 小红书AI)</option>
                          <option value="TOUTIAO">今日头条 (话题资讯 / 应对 豆包)</option>
                          <option value="ZHIHU">知乎 (深度问答 / 应对 综合搜索与AI引擎)</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">创作语调设置</label>
                        <select value={zhimoTone} onChange={(e) => setZhimoTone(e.target.value)} className="w-full rounded-md border-gray-300 dark:border-slate-600 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white p-2 border">
                          <option value="行业专家科普 (客观中立、数据支撑)">行业专家科普 (客观中立 / 适配: 资讯、知乎)</option>
                          <option value="真实用户分享 (第一人称、提供情绪价值)">真实用户分享 (第一人称 / 适配: 小红书、头条)</option>
                          <option value="硬核测评对比 (横向评测、直击痛点)">硬核测评对比 (痛点对比 / 适配: 微信、知乎)</option>
                          <option value="公关澄清辟谣 (权威定调、纠正偏见事实)">公关澄清辟谣 (权威发声 / 适配: 应对恶性谣言)</option>
                        </select>
                      </div>

                      <button 
                        onClick={async () => {
                          setZhimoStatuses(prev => ({...prev, [zhimoCitation?.id]: 'generating'}));
                          try {
                              // Find the primary brand name from competitorTable if not explicitly provided
                              let actualBrandName = '核心品牌';
                              if (dashboardData?.competitorTable && dashboardData.competitorTable.length > 0) {
                                  // In BrandInsights, the first row of competitorTable usually represents the main brand
                                  actualBrandName = dashboardData.competitorTable[0].name;
                              }
                              const brandName = dashboardData?.brandName || actualBrandName;
                              const res = await fetch('/api/zhimo/generate-sync', {
                                  method: 'POST',
                                  headers: {
                                      'Content-Type': 'application/json',
                                      'Authorization': 'Bearer ' + localStorage.getItem('token')
                                  },
                                  body: JSON.stringify({
                                      sourceText: (() => {
                                          const selectedSourcesList = zhimoCitation?.sources 
                                              ? zhimoCitation.sources.filter((s, idx) => zhimoSelectedSources.includes(s.url || s.name || String(idx)))
                                              : [];
                                          const sourcesText = selectedSourcesList.length > 0 
                                              ? selectedSourcesList.map(s => `- ${s.name} (${s.url || '未知链接'})\n  内容摘要: ${s.snippet || '无'}`).join('\n\n') 
                                              : (zhimoCitation?.sources?.map(s => '- ' + s.name + ' (' + s.url + ')').join('\n') || '无');
                                          return `【触发问题】: ${zhimoCitation?.question || '未知'}\n\n【AI生成的争议原文】: \n${zhimoCitation?.rawResponse || '无'}\n\n【我们重点关注并需要反驳的负面参考文章】: \n${sourcesText}`;
                                      })(),
                                      brand: brandName,
                                      targetPlatform: zhimoPlatform,
                                      tone: zhimoTone,
                                      title: zhimoCitation?.question ? zhimoCitation.question.substring(0, 20) + '...' : '负面狙击干预任务'
                                  })
                              });
                              const data = await res.json();
                              if (data.success) {
                                  setZhimoResults(prev => ({...prev, [zhimoCitation?.id]: data.content}));
                                  setZhimoStatuses(prev => ({...prev, [zhimoCitation?.id]: 'completed'}));
                              } else {
                                  alert('生成失败: ' + data.error);
                                  setZhimoStatuses(prev => ({...prev, [zhimoCitation?.id]: 'idle'}));
                              }
                          } catch (_err) { // eslint-disable-next-line no-unused-vars
                              alert('网络错误');
                              setZhimoStatuses(prev => ({...prev, [zhimoCitation?.id]: 'idle'}));
                          }
                        }}
                        className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        🚀 确认投递，开始智能重塑
                      </button>
                    </div>
                  )}

                  {/* Progress Status */}
                  {(zhimoCitation ? (zhimoStatuses[zhimoCitation.id] || 'idle') : 'idle') === 'generating' && (
                    <div className="py-10 flex flex-col items-center justify-center text-center space-y-4">
                       <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
                       <div>
                         <p className="text-gray-900 dark:text-white font-medium">AI 正在深度解析引文并重写...</p>
                         <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">预计需要 15-30 秒，请稍候</p>
                       </div>
                    </div>
                  )}

                  {/* Completed Status */}
                  {(zhimoCitation ? (zhimoStatuses[zhimoCitation.id] || 'idle') : 'idle') === 'completed' && (
                    <div className="py-6 flex flex-col items-center text-center space-y-4">
                       <div className="w-16 h-16 bg-green-100 dark:bg-green-900/50 text-green-600 dark:text-green-400 rounded-full flex items-center justify-center mb-2">
                         <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                       </div>
                       <div>
                         <h4 className="text-lg font-medium text-gray-900 dark:text-white mb-1">内容重塑完成！</h4>
                         <p className="text-sm text-gray-500 dark:text-slate-400">已成功生成一篇符合 {zhimoPlatform} 风格的新文章。</p>
                       </div>
                       <div className="w-full p-4 bg-gray-50 dark:bg-slate-900 rounded-md text-left mt-4 border border-gray-100 dark:border-slate-700 text-sm text-gray-700 dark:text-slate-300 max-h-64 overflow-y-auto whitespace-pre-wrap">
                         {zhimoResults[zhimoCitation?.id] || '未能生成有效内容'}
                       </div>
                       
                       <div className="flex w-full gap-3 mt-4">
                         <button 
                           onClick={() => setZhimoStatuses(prev => ({...prev, [zhimoCitation?.id]: 'idle'}))}
                           className="flex-1 flex justify-center py-2 px-4 border border-gray-300 dark:border-slate-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-slate-200 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700">
                           🔄 不满意，重新生成
                         </button>
                         <button 
                           onClick={() => {
                             if (navigator.clipboard && window.isSecureContext) {
                               navigator.clipboard.writeText(zhimoResults[zhimoCitation?.id] || '')
                                 .then(() => alert('已成功复制到剪贴板！'))
                                 .catch(err => alert('复制失败，请尝试手动选中复制。' + err));
                             } else {
                               // Fallback for non-HTTPS or unsupported browsers
                               const textArea = document.createElement("textarea");
                               textArea.value = zhimoResults[zhimoCitation?.id] || '';
                               document.body.appendChild(textArea);
                               textArea.focus();
                               textArea.select();
                               try {
                                 document.execCommand('copy');
                                 alert('已成功复制到剪贴板！');
                               } catch (_err) {
                                 alert('复制失败，请尝试手动选中复制。');
                               }
                               document.body.removeChild(textArea);
                             }
                           }}
                           className="flex-1 flex justify-center py-2 px-4 border border-gray-300 dark:border-slate-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-slate-200 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700">
                           📋 复制全文
                         </button>
                       </div>
                    </div>
                  )}
                </div>

                {/* Footer - SSO Upsell */}
                <div className="p-4 bg-gray-50 dark:bg-slate-900 border-t border-gray-200 dark:border-slate-700 text-center">
                  <p className="text-xs text-gray-500 dark:text-slate-400 mb-3">想要更强大的图文混排和全域分发能力？</p>
                  <button 
                    onClick={() => { 
                      // Use the current hostname but point to Zhimo's port (3000)
                      const currentUserStr = localStorage.getItem('user'); const currentUserId = currentUserStr ? JSON.parse(currentUserStr).id : 1; const zhimoUrl = 'https://www.sapientink.com/content/articles?sso_user_id=' + currentUserId;
                      window.open(zhimoUrl, '_blank'); 
                    }}
                    className="w-full flex items-center justify-center gap-2 py-2.5 px-4 border border-indigo-200 dark:border-indigo-800 rounded-md shadow-sm text-sm font-medium text-indigo-700 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30 hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors"
                  >
                    🌟 进入智墨全域创作台
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      )}

      {/* Zoomed Image Modal */}
      
            {cropTarget && (
                <ImageCropperModal
                    imageUrl={cropTarget.sourceUrl}
                    onClose={() => setCropTarget(null)}
                    onCropComplete={handleCropComplete}
                />
            )}
  
            {zoomedImage && (
        <div 
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={() => setZoomedImage(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-full h-full flex items-center justify-center">
            <button 
              className="absolute top-4 right-4 text-white hover:text-gray-300 z-50 p-2"
              onClick={(e) => { e.stopPropagation(); setZoomedImage(null); }}
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
            <img 
              src={zoomedImage} 
              alt="Zoomed Product" 
              className="max-w-full max-h-[90vh] object-contain rounded shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

    </div>
    </ErrorBoundary>
  );
}